<template>
    <div style="color: #32325d">
      <br />
      <table class="col-md-11">
        <tr>
          <td colspan="12" width="100%">
            <center>
              <h2>
                <b style="text-transform: uppercase">
                  DETAILED REPORT FOR
                  <span id="district">{{
                    dinrFormsData.district.admin2_name_en
                  }}</span>
                </b>
              </h2>
            </center>
          </td>
        </tr>
        <tr>
          <td colspan="6" width="50%">
            <b>Affected TAs</b>
            :
            <span>
              {{ TAarray.join() == "" ? "Not reported" : TAarray.join(", ") }}
            </span>
          </td>
  
          <td colspan="6" width="50%">
            <b>Affected Villages</b>
            :
            <span>
              {{
                villagesArray
                  .filter(Boolean)
                  .sort((a, b) => a.localeCompare(b))
                  .join(", ") || "Not reported"
              }}
            </span>
          </td>
        </tr>
        <tr>
          <td colspan="6" width="50%" style="text-transform: capitalize">
            <b>Type of disasters</b>
            : <span id="disastertype"> {{ dinrFormsData.disaster }} </span>
          </td>
          <td colspan="6" width="50%">
            <b>Report submitted at</b>
            :
            {{
              dateFormate(
                new Date(dinrFormsData.createdon).toLocaleDateString("en-US")
              )
            }}
          </td>
        </tr>
        <tr>
          <td colspan="6" width="50%">
            <b>Date Disaster started</b>
            :
            <span id="disasterstart">
              {{
                dateFormate(
                  new Date(dinrFormsData.dodFrom).toLocaleDateString("en-US")
                )
              }}
            </span>
          </td>
          <td colspan="6" width="50%">
            <b>Date Disaster ended</b>
            :
            {{
              dateFormate(
                new Date(dinrFormsData.dodTo).toLocaleDateString("en-US")
              )
            }}
          </td>
        </tr>
  
        <tr>
          <td colspan="4">
            <b>Date of assessment by ADRMC/VDRMC</b>
            :
            {{
              dateFormate(
                new Date(dinrFormsData.doaAcpc).toLocaleDateString("en-US")
              )
            }}
          </td>
          <td colspan="4">
            <b>Date of assessment/verification by DDRMC</b>
            :
            {{
              dateFormate(
                new Date(dinrFormsData.doaDcpc).toLocaleDateString("en-US")
              )
            }}
          </td>
          <td colspan="4">
            <b>Date reported to the DEC</b>
            :
            {{
              dinrFormsData.dateReported
                ? dateFormate(
                    new Date(dinrFormsData.dateReported).toLocaleDateString(
                      "en-US"
                    )
                  )
                : ""
            }}
          </td>
        </tr>
      </table>
  
      <table
        v-for="(item, index) in draFormsData"
        v-bind:key="index"
        class="col-md-11"
      >
        <!-- display ta name -->
        <tr>
          <td colspan="15">
            <h3 class="text-center" style="text-transform: uppercase">
              {{ item.admin3.admin3Name_en }}
            </h3>
          </td>
        </tr>
        <!-- end display ta name -->
  
        <tr>
          <td colspan="4" style="width: 35%">
            <b>
              <b>GVH</b>
            </b>
            :
            <span class="text-wrap">{{
              sortArrayByKey(item.gvhs)
                .map(e => e.name.replace(/(\r\n|\n|\r)/gm, ""))
                .join(", ") || "Not reported"
            }}</span>
          </td>
          <td colspan="4" style="width: 30%">
            <b>Camps</b>
            :
            <span class="text-wrap">{{
              item.camps
                .map(i => i.name)
                .filter(Boolean)
                .sort((a, b) => a.localeCompare(b))
                .join(", ") || "Not reported"
            }}</span>
          </td>
  
          <td colspan="4" style="width: 35%">
            <b>Affected Villages</b>
            :
            <span class="text-wrap">{{
              item.villages
                .map(i => i.name)
                .filter(Boolean)
                .sort((a, b) => a.localeCompare(b))
                .join(", ") || "Not reported"
            }}</span>
          </td>
        </tr>
         <!-- general -->
                <tr
                  v-if="item.sectors.shelter"
                  style="margin-botton:9padding:0 !important;border:0px !important;"
                >
                  <td
                    colspan="15"
                    style="margin:0 !important;padding:0 !important;border:0px"
                  >
                    <table
                      width="100%"
                      style="margin:0;padding:0 !important;border:0px !important;"
                    >
                      <tr
                        v-if="
                          (item.sectors.shelter.PeopleInjuredrows &&
                            item.sectors.shelter.PeopleInjuredrows.length > 0) ||
                            (item.sectors.shelter.PeopleDeadrows &&
                              item.sectors.shelter.PeopleDeadrows.length > 0)
                        "
                      >
                        <td colspan="13" class="text-center">
                          <span><b>GENERAL INFORMATION </b></span>
                        </td>
                      </tr>
                      <!-- people injured start -->
                      <tr
                        v-if="
                          item.sectors.shelter.PeopleInjuredrows &&
                            item.sectors.shelter.PeopleInjuredrows.length > 0
                        "
                      >
                        <td
                          width="20%"
                          :rowspan="
                            item.sectors.shelter.PeopleInjuredrows.length > 0
                              ? item.sectors.shelter.PeopleInjuredrows.length + 2
                              : item.sectors.shelter.PeopleInjuredrows.length + 1
                          "
                        >
                          <strong>People Injured</strong>
                        </td>
                        <td colspan="6" width="40%">
                          <b>GVH</b>
                        </td>
                        <td colspan="2" width="10%">
                          <b>
                            <center>Male</center>
                          </b>
                        </td>
                        <td colspan="2" width="10%">
                          <b>
                            <center>Female</center>
                          </b>
                        </td>
                        <td colspan="2" width="10%" style="font-weight:bold">
                          <b>
                            <center>Total</center>
                          </b>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          item.sectors.shelter.PeopleInjuredrows &&
                            item.sectors.shelter.PeopleInjuredrows.length > 0
                        "
                        v-for="row in item.sectors.shelter.PeopleInjuredrows"
                      >
                        <td width="40%" colspan="6">
                         <b> {{ row.name || "Not reported" }}</b> <br/>
                          {{ "Adults Over 18" }} <br/>
                          {{ "Under 18" }} <br/>
                        </td>
                        <td width="10%" colspan="2" class="right-align">
                          {{ }} <br/>
                          {{ numberWithCommas(row.adults_males_injured || 0) }} <br/>
                          {{ numberWithCommas(row.children_males_injured || 0) }} <br/>
                        </td>
                        <td width="10%" colspan="2" class="right-align">
                         {{ }} <br/>
                          {{ numberWithCommas(row.adults_females_injured || 0) }} <br/>
                          {{ numberWithCommas(row.children_females_injured || 0) }} <br/>
                        </td>
                        <td
                          style="font-weight:bold"
                          width="10%"
                          colspan="2"
                          class="right-align"
                        >
                        {{
                          }} <br/>
                          {{
                            numberWithCommas(
                              (row.adults_males_injured
                                ? parseInt(row.adults_males_injured)
                                : 0) +
                                (row.adults_females_injured
                                  ? parseInt(row.adults_females_injured)
                                  : 0)
                            )
                          }}<br/>
                          {{
                            numberWithCommas(
                              (row.children_males_injured
                                ? parseInt(row.children_males_injured)
                                : 0) +
                                (row.children_females_injured
                                  ? parseInt(row.children_females_injured)
                                  : 0)
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          item.sectors.shelter.PeopleInjuredrows &&
                            item.sectors.shelter.PeopleInjuredrows.length > 0
                        "
                      >
                        <td width="40%" style="font-weight:bold" colspan="6">
                          Total
                        </td>
                        <td
                          width="10%"
                          colspan="2"
                          style="font-weight:bold;"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
                              item.sectors.shelter.PeopleInjuredrows
                                ? item.sectors.shelter.PeopleInjuredrows.map(
                                    function(item) {
                                      let adult = item.adults_males_injured
                                        ? parseInt(item.adults_males_injured)
                                        : 0;
                                        let children = item.children_males_injured
                                        ? parseInt(item.children_males_injured)
                                        : 0;
                                        let sum = adult + children
                                        return sum
                                    }
                                  ).reduce((sum, value) => sum + value)
                                : 0
                            )
                          }}
                        </td>
                        <td
                          width="10%"
                          colspan="2"
                          style="font-weight:bold"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
                              item.sectors.shelter.PeopleInjuredrows
                                ? item.sectors.shelter.PeopleInjuredrows.map(
                                    function(item) {
                                      let adult = item.adults_females_injured
                                        ? parseInt(item.adults_females_injured)
                                        : 0;
                                        let children = item.children_females_injured
                                        ? parseInt(item.children_females_injured)
                                        : 0;
                                        let sum = adult + children
                                        return sum
                                    }
                                  ).reduce((sum, value) => sum + value)
                                : 0
                            )
                          }}
                        </td>
                        <td
                          width="10%"
                          colspan="2"
                          style="font-weight:bold"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
                              (item.sectors.shelter.PeopleInjuredrows
                                ? item.sectors.shelter.PeopleInjuredrows.map(
                                    function(item) {
                                      let adult = item.adults_males_injured
                                        ? parseInt(item.adults_males_injured)
                                        : 0;
                                        let children = item.children_males_injured
                                        ? parseInt(item.children_males_injured)
                                        : 0;
                                        let sum = adult + children
                                        return sum
                                    }
                                  ).reduce((sum, value) => sum + value)
                                : 0) +
                                (item.sectors.shelter.PeopleInjuredrows
                                ? item.sectors.shelter.PeopleInjuredrows.map(
                                    function(item) {
                                      let adult = item.adults_females_injured
                                        ? parseInt(item.adults_females_injured)
                                        : 0;
                                        let children = item.children_females_injured
                                        ? parseInt(item.children_females_injured)
                                        : 0;
                                        let total = adult + children
                                        return total
                                    }
                                  ).reduce((sumf, value) => sumf + value)
                                : 0)
                            )
                          }}
                        </td>
                      </tr>
                      <!-- people injured end -->
                      <!-- people dead start -->
                      <tr
                        v-if="
                          item.sectors.shelter.PeopleDeadrows &&
                            item.sectors.shelter.PeopleDeadrows.length > 0
                        "
                      >
                        <td
                          width="20%"
                          :rowspan="
                            item.sectors.shelter.PeopleDeadrows.length > 0
                              ? item.sectors.shelter.PeopleDeadrows.length + 2
                              : item.sectors.shelter.PeopleDeadrows + 1
                          "
                        >
                          <b>People Dead</b>
                        </td>
                        <td width="20%" colspan="3">
                          <b>GVH</b>
                        </td>
                        <td width="20%" colspan="3">
                          <b>Cause</b>
                        </td>
                        <td colspan="2" width="10%">
                          <b>
                            <center>Male</center>
                          </b>
                        </td>
                        <td colspan="2" width="10%">
                          <b>
                            <center>Female</center>
                          </b>
                        </td>
                        <td colspan="2" width="10%">
                          <b>
                            <center>Total</center>
                          </b>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          item.sectors.shelter.PeopleDeadrows &&
                            item.sectors.shelter.PeopleDeadrows.length > 0
                        "
                        v-for="row in item.sectors.shelter.PeopleDeadrows"
                      >
                        <td width="20%" colspan="3">
                         <b> {{ row.name || "Not reported" }} </b> <br/>
                          {{ "Adults Over 18" }} <br/>
                          {{ "Under 18" }} <br/>
                        </td>
                        <td width="20%" colspan="3">
                          {{  }}
                          {{ row.adults_cause_of_death || 0 }} <br/>
                          {{ row.children_cause_of_death || 0 }}
                        </td>
                        <td width="10%" colspan="2" class="right-align">
                          {{  }}<br/>
                          {{ numberWithCommas(row.adults_males_dead || 0) }}<br/>
                          {{ numberWithCommas(row.children_males_dead || 0) }}
                        </td>
                        <td width="10%" colspan="2" class="right-align">
                          {{  }}<br/>
                          {{ numberWithCommas(row.adults_females_dead || 0) }}<br/>
                          {{ numberWithCommas(row.children_females_dead || 0) }}
                        </td>
                        <td
                          width="10%"
                          colspan="2"
                          style="font-weight:bold"
                          class="right-align"
                        >
                          {{
                          }} <br/>
                          {{
                            numberWithCommas(
                              (row.adults_males_dead ? parseInt(row.adults_males_dead) : 0) +
                                (row.adults_females_dead
                                  ? parseInt(row.adults_females_dead)
                                  : 0)
                            )
                          }} <br/>
                          {{
                            numberWithCommas(
                              (row.children_males_dead ? parseInt(row.children_males_dead) : 0) +
                                (row.children_females_dead
                                  ? parseInt(row.children_females_dead)
                                  : 0)
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          item.sectors.shelter.PeopleDeadrows &&
                            item.sectors.shelter.PeopleDeadrows.length > 0
                        "
                      >
                        <td width="40%" colspan="6" style="font-weight:bold">
                          Total
                        </td>
                        <td
                          width="10%"
                          colspan="2"
                          style="font-weight:bold"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
                              item.sectors.shelter.PeopleDeadrows
                                ? item.sectors.shelter.PeopleDeadrows.map(
                                    function(item) {
                                    let adult = item.adults_males_dead
                                        ? parseInt(item.adults_males_dead)
                                        : 0;
  
                                    let children = item.children_males_dead
                                        ? parseInt(item.children_males_dead)
                                        : 0;
                                        let sum = adult + children
                                        return sum}
                                  ).reduce((sum, value) => sum + value)
                                : 0
                            )
                          }}
                        </td>
                        <td
                          style="font-weight:bold"
                          width="10%"
                          colspan="2"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
                              item.sectors.shelter.PeopleDeadrows
                                ? item.sectors.shelter.PeopleDeadrows.map(
                                    function(item) {
                                    let adult = item.adults_females_dead
                                        ? parseInt(item.adults_females_dead)
                                        : 0;
  
                                    let children = item.children_females_dead
                                        ? parseInt(item.children_females_dead)
                                        : 0;
                                        let sum = adult + children
                                        return sum}
                                  ).reduce((sum, value) => sum + value)
                                : 0
                            )
                          }}
                        </td>
                        <td
                          width="10%"
                          colspan="2"
                          style="font-weight:bold"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
  
                                (item.sectors.shelter.PeopleDeadrows
                                ? item.sectors.shelter.PeopleDeadrows.map(
                                    function(item) {
                                    let adult = item.adults_females_dead
                                        ? parseInt(item.adults_females_dead)
                                        : 0;
  
                                    let children = item.children_females_dead
                                        ? parseInt(item.children_females_dead)
                                        : 0;
                                        let sumf = adult + children
                                        return sumf}
                                  ).reduce((sumg, value) => sumg + value)
                                : 0) + (item.sectors.shelter.PeopleDeadrows
                                ? item.sectors.shelter.PeopleDeadrows.map(
                                    function(item) {
                                    let adult = item.adults_males_dead
                                        ? parseInt(item.adults_males_dead)
                                        : 0;
  
                                    let children = item.children_males_dead
                                        ? parseInt(item.children_males_dead)
                                        : 0;
                                        let sum = adult + children
                                        return sum}
                                  ).reduce((sum, value) => sum + value)
                                : 0)
                            )
                          }}
                        </td>
                      </tr>
                      <!-- people dead end -->
                      <!-- people missing start -->
                      <tr
                        v-if="
                          item.sectors.shelter.PeopleMissingrows &&
                            item.sectors.shelter.PeopleMissingrows.length > 0
                        "
                      >
                        <td
                          width="20%"
                          :rowspan="
                            item.sectors.shelter.PeopleMissingrows.length > 0
                              ? item.sectors.shelter.PeopleMissingrows.length + 2
                              : item.sectors.shelter.PeopleMissingrows.length + 1
                          "
                        >
                          <strong>People Missing</strong>
                        </td>
                        <td colspan="6" width="40%">
                          <b>GVH</b>
                        </td>
                        <td colspan="2" width="10%">
                          <b>
                            <center>Male</center>
                          </b>
                        </td>
                        <td colspan="2" width="10%">
                          <b>
                            <center>Female</center>
                          </b>
                        </td>
                        <td colspan="2" width="10%" style="font-weight:bold">
                          <b>
                            <center>Total</center>
                          </b>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          item.sectors.shelter.PeopleMissingrows &&
                            item.sectors.shelter.PeopleMissingrows.length > 0
                        "
                        v-for="row in item.sectors.shelter.PeopleMissingrows"
                      >
                        <td width="40%" colspan="6">
                         <b> {{ row.name || "Not reported" }}</b> <br/>
                          {{ "Adults Over 18" }} <br/>
                          {{ "Under 18" }} <br/>
                        </td>
                        <td width="10%" colspan="2" class="right-align">
                          {{ }} <br/>
                          {{ numberWithCommas(row.adults_males_missing || 0) }} <br/>
                          {{ numberWithCommas(row.children_males_missing || 0) }} <br/>
                        </td>
                        <td width="10%" colspan="2" class="right-align">
                         {{ }} <br/>
                          {{ numberWithCommas(row.adults_females_missing || 0) }} <br/>
                          {{ numberWithCommas(row.children_females_missing || 0) }} <br/>
                        </td>
                        <td
                          style="font-weight:bold"
                          width="10%"
                          colspan="2"
                          class="right-align"
                        >
                        {{
                          }} <br/>
                          {{
                            numberWithCommas(
                              (row.adults_males_missing
                                ? parseInt(row.adults_males_missing)
                                : 0) +
                                (row.adults_females_missing
                                  ? parseInt(row.adults_females_missing)
                                  : 0)
                            )
                          }}<br/>
                          {{
                            numberWithCommas(
                              (row.children_males_missing
                                ? parseInt(row.children_males_missing)
                                : 0) +
                                (row.children_females_missing
                                  ? parseInt(row.children_females_missing)
                                  : 0)
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          item.sectors.shelter.PeopleMissingrows &&
                            item.sectors.shelter.PeopleMissingrows.length > 0
                        "
                      >
                        <td width="40%" style="font-weight:bold" colspan="6">
                          Total
                        </td>
                        <td
                          width="10%"
                          colspan="2"
                          style="font-weight:bold;"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
                              item.sectors.shelter.PeopleMissingrows
                                ? item.sectors.shelter.PeopleMissingrows.map(
                                    function(item) {
                                      let adult = item.adults_males_missing
                                        ? parseInt(item.adults_males_missing)
                                        : 0;
                                        let children = item.children_males_missing
                                        ? parseInt(item.children_males_missing)
                                        : 0;
                                        let sum = adult + children
                                        return sum
                                    }
                                  ).reduce((sum, value) => sum + value)
                                : 0
                            )
                          }}
                        </td>
                        <td
                          width="10%"
                          colspan="2"
                          style="font-weight:bold"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
                              item.sectors.shelter.PeopleMissingrows
                                ? item.sectors.shelter.PeopleMissingrows.map(
                                    function(item) {
                                      let adult = item.adults_females_missing
                                        ? parseInt(item.adults_females_missing)
                                        : 0;
                                        let children = item.children_females_missing
                                        ? parseInt(item.children_females_missing)
                                        : 0;
                                        let sum = adult + children
                                        return sum
                                    }
                                  ).reduce((sum, value) => sum + value)
                                : 0
                            )
                          }}
                        </td>
                        <td
                          width="10%"
                          colspan="2"
                          style="font-weight:bold"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
                              (item.sectors.shelter.PeopleMissingrows
                                ? item.sectors.shelter.PeopleMissingrows.map(
                                    function(item) {
                                      let adult = item.adults_males_missing
                                        ? parseInt(item.adults_males_missing)
                                        : 0;
                                        let children = item.children_males_missing
                                        ? parseInt(item.children_males_missing)
                                        : 0;
                                        let sum = adult + children
                                        return sum
                                    }
                                  ).reduce((sum, value) => sum + value)
                                : 0) +
                                (item.sectors.shelter.PeopleMissingrows
                                ? item.sectors.shelter.PeopleMissingrows.map(
                                    function(item) {
                                      let adult = item.adults_females_missing
                                        ? parseInt(item.adults_females_missing)
                                        : 0;
                                        let children = item.children_females_missing
                                        ? parseInt(item.children_females_missing)
                                        : 0;
                                        let total = adult + children
                                        return total
                                    }
                                  ).reduce((sumf, value) => sumf + value)
                                : 0)
                            )
                          }}
                        </td>
                      </tr>
                      <!-- people missing end -->
                    </table>
                  </td>
                </tr>
                <tr
                  style="border:none"
                  v-if="
                    (item.sectors.shelter.PeopleInjuredrows &&
                      item.sectors.shelter.PeopleInjuredrows.length > 0) ||
                      (item.sectors.shelter.PeopleDeadrows &&
                        item.sectors.shelter.PeopleDeadrows.length > 0)
                  "
                >
                  <td class="col-md-12" colspan="16"></td>
                </tr>
                <!-- end general -->
        <!-- shelter -->
        <tr
          v-if="item.sectors.shelter"
          style="
                    margin: 0 !important;
                    padding: 0 !important;
                    border: 0px !important;
                  "
        >
          <td
            colspan="15"
            style="
                      margin: 0 !important;
                      padding: 0 !important;
                      border: 0px;
                    "
          >
            <table
              width="100%"
              style="
                        margin: 0;
                        padding: 0 !important;
                        border: 0px !important;
                      "
            >
              <tr>
                <td style="text-align: left">
                  <b>CLUSTER</b>
                </td>
                <td colspan="13" class="text-center">
                  <b>IMPACT ASSESSMENT</b>
                </td>
              </tr>
              <tr>
                <td
                  width="10%"
                  class="clearfix"
                  :rowspan="
                    (item.sectors.shelter.people_without_shelter
                      ? item.sectors.shelter.people_without_shelter.length > 0
                        ? item.sectors.shelter.people_without_shelter.length + 2
                        : 1
                      : 1) +
                      (item.sectors.shelter.PeopleAffectedrows
                        ? item.sectors.shelter.PeopleAffectedrows.length > 0
                          ? item.sectors.shelter.PeopleAffectedrows.length + 2
                          : 1
                        : 1) +
                      4
                  "
                >
                  <span class="rotated" style="font-weight: bold"></span>
                  <img
                    src="../../../../static/cluster_shelter_100px_bluebox.png"
                    height="150"
                  />
                </td>
              </tr>
              <tr v-if="item.sectors.shelter.people_without_shelter">
                <td width="20%">
                  <b>Indicators</b>
                </td>
                <td colspan="6" width="40%">
                  <b>Category</b>
                </td>
                <td width="10%" colspan="2">
                  <b>
                    <center>Male</center>
                  </b>
                </td>
                <td width="10%" colspan="2">
                  <b>
                    <center>Female</center>
                  </b>
                </td>
                <td width="10%" colspan="2">
                  <b>
                    <center>Total</center>
                  </b>
                </td>
              </tr>
              <tr v-if="item.sectors.shelter.people_without_shelter">
                <td
                  width="20%"
                  :rowspan="
                    item.sectors.shelter.people_without_shelter.length > 0
                      ? item.sectors.shelter.people_without_shelter.length + 2
                      : item.sectors.shelter.people_without_shelter.length + 1
                  "
                >
                  <strong>People without shelter</strong>
                </td>
              </tr>
              <tr
                v-for="row in item.sectors.shelter.people_without_shelter"
                v-if="item.sectors.shelter.people_without_shelter"
                style="border: 1px"
              >
                <td width="40%" colspan="6">
                  {{ row.name || "Not reported" }}
                </td>
                <td width="10%" colspan="2" class="right-align">
                  {{ numberWithCommas(row.males || 0) }}
                </td>
                <td width="10%" colspan="2" class="right-align">
                  {{ numberWithCommas(row.females || 0) }}
                </td>
                <td
                  width="10%"
                  colspan="2"
                  style="font-weight: bold"
                  class="right-align"
                >
                  {{
                    numberWithCommas(
                      (row.females ? parseInt(row.females) : 0) +
                        (row.males ? parseInt(row.males) : 0) || 0
                    )
                  }}
                </td>
              </tr>
  
              <tr
                v-if="
                  item.sectors.shelter.people_without_shelter &&
                    item.sectors.shelter.people_without_shelter.length > 0
                "
              >
                <td width="40%" style="font-weight: bold" colspan="6">
                  Total
                </td>
                <td width="10%" colspan="2" class="right-align">
                  {{
                    numberWithCommas(
                      item.sectors.shelter.people_without_shelter
                        ? item.sectors.shelter.people_without_shelter
                            .map(function(item) {
                              return item.males ? parseInt(item.males) : 0;
                            })
                            .reduce((sum, value) => sum + value)
                        : 0
                    )
                  }}
                </td>
                <td
                  width="10%"
                  colspan="2"
                  style="font-weight: bold"
                  class="right-align"
                >
                  {{
                    numberWithCommas(
                      item.sectors.shelter.people_without_shelter
                        ? item.sectors.shelter.people_without_shelter
                            .map(function(item) {
                              return item.females ? parseInt(item.females) : 0;
                            })
                            .reduce((sum, value) => sum + value)
                        : 0
                    )
                  }}
                </td>
                <td
                  width="10%"
                  colspan="2"
                  style="font-weight: bold"
                  class="right-align"
                >
                  {{
                    numberWithCommas(
                      (item.sectors.shelter.people_without_shelter
                        ? item.sectors.shelter.people_without_shelter
                            .map(function(item) {
                              return item.males ? parseInt(item.males) : 0;
                            })
                            .reduce((sum, value) => sum + value)
                        : 0) +
                        (item.sectors.shelter.people_without_shelter
                          ? item.sectors.shelter.people_without_shelter
                              .map(function(item) {
                                return item.females ? parseInt(item.females) : 0;
                              })
                              .reduce((sum, value) => sum + value)
                          : 0)
                    )
                  }}
                </td>
              </tr>
  
              <tr v-if="item.sectors.shelter.PeopleAffectedrows">
                <td
                  width="20%"
                  :rowspan="
                    item.sectors.shelter.PeopleAffectedrows.length > 0
                      ? item.sectors.shelter.PeopleAffectedrows.length + 2
                      : item.sectors.shelter.PeopleAffectedrows.length + 1
                  "
                >
                  <strong>Households Affected</strong>
                </td>
                <td width="40%" colspan="6">
                  <b>GVH</b>
                </td>
                <td width="10%" colspan="2" style>
                  <b>
                    <center>Male HH</center>
                  </b>
                </td>
                <td width="10%" colspan="2">
                  <b>
                    <center>Female HH</center>
                  </b>
                </td>
                <td width="10%" style="font-weight: bold" colspan="2">
                  <b>
                    <center>Total</center>
                  </b>
                </td>
              </tr>
              <tr
                v-if="item.sectors.shelter.PeopleAffectedrows"
                v-for="row in item.sectors.shelter.PeopleAffectedrows"
              >
                <td width="40%" colspan="6">
                  {{ row.name || "Not reported" }}
                </td>
                <td width="10%" colspan="2" class="right-align">
                  {{ numberWithCommas(row.damaged_mhh || 0) }}
                </td>
                <td width="10%" colspan="2" class="right-align">
                  {{ numberWithCommas(row.damaged_fhh || 0) }}
                </td>
                <td
                  style="font-weight: bold"
                  width="10%"
                  colspan="2"
                  class="right-align"
                >
                  {{
                    numberWithCommas(
                      (row.damaged_fhh ? parseInt(row.damaged_fhh) : 0) +
                        (row.damaged_mhh ? parseInt(row.damaged_mhh) : 0) || 0
                    )
                  }}
                </td>
              </tr>
              <tr
                v-if="
                  item.sectors.shelter.PeopleAffectedrows &&
                    item.sectors.shelter.PeopleAffectedrows.length > 0
                "
              >
                <td style="font-weight: bold" width="40%" colspan="6">
                  Total
                </td>
                <td
                  style="font-weight: bold"
                  colspan="2"
                  width="10%"
                  class="right-align"
                >
                  {{
                    numberWithCommas(
                      item.sectors.shelter.PeopleAffectedrows
                        ? item.sectors.shelter.PeopleAffectedrows.map(function(
                            item
                          ) {
                            return item.damaged_mhh
                              ? parseInt(item.damaged_mhh)
                              : 0;
                          }).reduce((sum, value) => sum + value)
                        : 0
                    )
                  }}
                </td>
                <td
                  style="font-weight: bold"
                  colspan="2"
                  width="10%"
                  class="right-align"
                >
                  {{
                    numberWithCommas(
                      item.sectors.shelter.PeopleAffectedrows
                        ? item.sectors.shelter.PeopleAffectedrows.map(function(
                            item
                          ) {
                            return item.damaged_fhh
                              ? parseInt(item.damaged_fhh)
                              : 0;
                          }).reduce((sum, value) => sum + value)
                        : 0
                    )
                  }}
                </td>
                <td
                  style="font-weight: bold"
                  colspan="2"
                  width="10%"
                  class="right-align"
                >
                  {{
                    numberWithCommas(
                      (item.sectors.shelter.PeopleAffectedrows
                        ? item.sectors.shelter.PeopleAffectedrows.map(function(
                            item
                          ) {
                            return item.damaged_mhh
                              ? parseInt(item.damaged_mhh)
                              : 0;
                          }).reduce((sum, value) => sum + value)
                        : 0) +
                        (item.sectors.shelter.PeopleAffectedrows
                          ? item.sectors.shelter.PeopleAffectedrows.map(function(
                              item
                            ) {
                              return item.damaged_fhh
                                ? parseInt(item.damaged_fhh)
                                : 0;
                            }).reduce((sum, value) => sum + value)
                          : 0)
                    )
                  }}
                </td>
              </tr>
              <tr>
                <td style="width: 20%">
                  <strong>Response Needed</strong>
                </td>
                <td colspan="14">
                  <u>
                    <strong>URGENT RESPONSE FOR NON FOOD ITEMS</strong>
                  </u>
                 <br />
                        <li
                          
                          style="margin-left: 2%"
                          class="qcont"
                          v-for="obj in item.sectors.shelter
                            .response_needed_non_food"
                          :key="obj"
                        >
                          <!-- {{
                            item.sectors.shelter
                              ? item.sectors.shelter.response_needed_non_food.name
                                ? item.sectors.shelter.response_needed_emergency
                                : "N/A"
                              : "N/A"
                          }} -->
                          {{ item.sectors.shelter
                            .response_needed_non_food.length > 0 ? obj.name : "NA" }}  {{ obj.specification }}  
                        </li>
  
                        <hr style="margin: 1%" />
                        <u>
                          <strong>EMERGENCY RESPONSE</strong>
                        </u>
                        <br />
                        <li
                          style="margin-left: 2%"
                          class="qcont"
                          v-for="obj in item.sectors.shelter
                            .response_needed_emergency"
                          :key="obj"
                          
                        >
                          <!-- {{
                            item.sectors.shelter
                              ? item.sectors.shelter.response_needed_non_food.name
                                ? item.sectors.shelter.response_needed_emergency
                                : "N/A"
                              : "N/A"
                          }} -->
                          {{ item.sectors.shelter
                            .response_needed_emergency.length > 0 ? obj.name : "NA" }}  {{ obj.specification }}
                        </li>
                         <hr style="margin: 1%" />
                        <u>
                        
                          <strong>GENERAL</strong>
                        </u>
                        <br />
                        <li style="margin-left: 2%" class="qcont">
                          {{
                            item.sectors.shelter
                              ? item.sectors.shelter.urgent_response_needed
                                ? item.sectors.shelter.urgent_response_needed
                                : "N/A"
                              : "N/A"
                          }}
                        </li>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- end shelter -->
        <!--  displaced -->
                <tr
                  v-if="item.sectors.displaced"
                  style="margin:0 !important;padding:0 !important;border:0px !important;"
                >
                  <td
                    colspan="15"
                    style="margin:0 !important;padding:0 !important;border:0px"
                  >
                    <table
                      width="100%"
                      style="margin:0;padding:0 !important;border:0px !important;"
                    >
                      <tr>
                        <td
                          width="10%"
                          colspan="2"
                          class="clearfix"
                          :rowspan="2 +
                            (item.sectors.displaced
                              .displaced_households_accommodated
                              ? item.sectors.displaced
                                  .displaced_households_accommodated.length > 0
                                ? 2
                                : 1
                              : 1) +
                              (item.sectors.displaced.PeopleAffectedrows
                                ? item.sectors.displaced.PeopleAffectedrows
                                    .length > 0
                                  ? item.sectors.displaced.PeopleAffectedrows
                                      .length + 3
                                  : 1
                                : 1) +
                              (item.sectors.displaced
                                .displaced_individuals_accommodated
                                ? item.sectors.displaced
                                    .displaced_individuals_accommodated.length > 0
                                  ? 2
                                  : 1
                                : 1)
                          "
                        >
                          <span class="rotated" style="font-weight: bold;"
                            ></span
                          >
                          <img
                            src="../../../../static/crisis_population_displacement_100px_bluebox.png"
                            height="150"
                          />
                        </td>
  
                         <td
                          v-if="item.sectors.displaced.displaced_households_accommodated"
                          :rowspan="
                            1 + item.sectors.displaced.displaced_households_accommodated.length
                          "
                          colspan="5"
                          style="width:20%"
                        >
                          <strong>Number of HH accomodated in difference structures</strong>
                        </td>
                        <td
                          colspan="3"
                          v-if="item.sectors.displaced.displaced_households_accommodated"
                          style="width:15%"
                        >
                          <b>Category</b>
                        </td>
                        <td
                          colspan="2"
                          v-if="item.sectors.displaced.displaced_households_accommodated"
                          style="width:15%"
                        >
                          <b>Name</b>
                        </td>
                        <td
                          v-if="item.sectors.displaced.displaced_households_accommodated"
                          colspan="2"
                          style="width:10%"
                        >
                          <b>Latitude</b>
                        </td>
                        <td
                          v-if="item.sectors.displaced.displaced_households_accommodated"
                          colspan="2"
                          style="width:10%"
                        >
                          <b>Longitude</b>
                        </td>
                        <td
                          v-if="item.sectors.displaced.displaced_households_accommodated"
                          colspan="2"
                          style="width:10%"
                        >
                          <b>Male</b>
                        </td>
                        <td
                          v-if="item.sectors.displaced.displaced_households_accommodated"
                          colspan="2"
                          style="width:10%"
                        >
                          <b>Female</b>
                        </td>
                      </tr>
                      <tr
                        v-if="item.sectors.displaced.displaced_households_accommodated"
                        v-for="row in item.sectors.displaced.displaced_households_accommodated"
                      >
                        <td colspan="2" style="width:15%">{{ row.name }}</td>
                        <td colspan="2" style="width:15%">{{ row.structure_name }}</td>
                        <td colspan="2" style="width:10%">{{ row.lat }}</td>
                        <td colspan="2" style="width:10%">{{ row.long }}</td>
                        <td colspan="2" style="width:10%">{{ row.accomodated_males_hh }}</td>
                        <td colspan="2" style="width:10%">{{ row.accomodated_females_hh }}</td>
                      </tr>
                      <!-- e -->
                      <tr
                        v-if="
                          item.sectors.displaced
                            .displaced_individuals_accommodated &&
                            item.sectors.displaced
                              .displaced_individuals_accommodated.length > 0
                        "
                      >
                        <td
                          colspan="12"
                          width="20%"
                          :rowspan="
                            item.sectors.displaced
                              .displaced_individuals_accommodated
                              ? item.sectors.displaced
                                  .displaced_individuals_accommodated.length > 0
                                ? 2
                                : 1
                              : 1
                          "
                        >
                          <strong
                            >Number of People accomodated in difference structures</strong
                          >
                        </td>
                        <td colspan="2" width="15%">
                          <b>
                            <center>Male</center>
                          </b>
                        </td>
                        <td colspan="2" width="15%">
                          <b>
                            <center>Female</center>
                          </b>
                        </td>
                        <td colspan="2" width="15%">
                          <b>
                            <center>Total</center>
                          </b>
                        </td>
                      </tr>
  
                      <tr
                        v-if="
                          item.sectors.displaced
                            .displaced_individuals_accommodated &&
                            item.sectors.displaced
                              .displaced_individuals_accommodated.length > 0
                        "
                      >
                        <td width="15%" colspan="2" class="right-align">
                          {{
                            numberWithCommas(
                              item.sectors.displaced
                                .displaced_individuals_accommodated
                                ? item.sectors.displaced.displaced_individuals_accommodated
                                    .map(function(item) {
                                      return item.accomodated_males
                                        ? parseInt(item.accomodated_males)
                                        : 0;
                                    })
                                    .reduce((sum, value) => sum + value)
                                : 0
                            )
                          }}
                        </td>
                        <td width="15%" colspan="2" class="right-align">
                          {{
                            numberWithCommas(
                              item.sectors.displaced
                                .displaced_individuals_accommodated
                                ? item.sectors.displaced.displaced_individuals_accommodated
                                    .map(function(item) {
                                      return item.accomodated_females
                                        ? parseInt(item.accomodated_females)
                                        : 0;
                                    })
                                    .reduce((sum, value) => sum + value)
                                : 0
                            )
                          }}
                        </td>
                        <td width="15%" colspan="2" class="right-align">
                          {{
                            numberWithCommas(
                              parseInt(
                                item.sectors.displaced
                                  .displaced_individuals_accommodated
                                  ? item.sectors.displaced.displaced_individuals_accommodated
                                      .map(function(item) {
                                        return item.accomodated_males
                                          ? parseInt(item.accomodated_males)
                                          : 0;
                                      })
                                      .reduce((sum, value) => sum + value)
                                  : 0
                              ) +
                                parseInt(
                                  item.sectors.displaced
                                    .displaced_individuals_accommodated
                                    ? item.sectors.displaced.displaced_individuals_accommodated
                                        .map(function(item) {
                                          return item.accomodated_females
                                            ? parseInt(item.accomodated_females)
                                            : 0;
                                        })
                                        .reduce((sum, value) => sum + value)
                                    : 0
                                )
                            )
                          }}
                        </td>
                      </tr>
                      <!--  -->
                      <tr
                        v-if="
                          item.sectors.displaced
                            .displaced_individuals_accommodated &&
                            item.sectors.displaced
                              .displaced_individuals_accommodated.length > 0
                        "
                      >
                        <td
                          colspan="12"
                          width="20%"
                          :rowspan="
                            item.sectors.displaced
                              .displaced_individuals_accommodated
                              ? item.sectors.displaced
                                  .displaced_individuals_accommodated.length > 0
                                ? 2
                                : 1
                              : 1
                          "
                        >
                          <strong
                            >Number of People accomodated in difference structures</strong
                          >
                        </td>
                        <td colspan="2" width="15%">
                          <b>
                            <center>Male</center>
                          </b>
                        </td>
                        <td colspan="2" width="15%">
                          <b>
                            <center>Female</center>
                          </b>
                        </td>
                        <td colspan="2" width="15%">
                          <b>
                            <center>Total</center>
                          </b>
                        </td>
                      </tr>
  
                      <tr
                        v-if="
                          item.sectors.displaced
                            .displaced_individuals_accommodated &&
                            item.sectors.displaced
                              .displaced_individuals_accommodated.length > 0
                        "
                      >
                        <td width="15%" colspan="2" class="right-align">
                          {{
                            numberWithCommas(
                              item.sectors.displaced
                                .displaced_individuals_accommodated
                                ? item.sectors.displaced.displaced_individuals_accommodated
                                    .map(function(item) {
                                      return item.accomodated_males
                                        ? parseInt(item.accomodated_males)
                                        : 0;
                                    })
                                    .reduce((sum, value) => sum + value)
                                : 0
                            )
                          }}
                        </td>
                        <td width="15%" colspan="2" class="right-align">
                          {{
                            numberWithCommas(
                              item.sectors.displaced
                                .displaced_individuals_accommodated
                                ? item.sectors.displaced.displaced_individuals_accommodated
                                    .map(function(item) {
                                      return item.accomodated_females
                                        ? parseInt(item.accomodated_females)
                                        : 0;
                                    })
                                    .reduce((sum, value) => sum + value)
                                : 0
                            )
                          }}
                        </td>
                        <td width="15%" colspan="2" class="right-align">
                          {{
                            numberWithCommas(
                              parseInt(
                                item.sectors.displaced
                                  .displaced_individuals_accommodated
                                  ? item.sectors.displaced.displaced_individuals_accommodated
                                      .map(function(item) {
                                        return item.accomodated_males
                                          ? parseInt(item.accomodated_males)
                                          : 0;
                                      })
                                      .reduce((sum, value) => sum + value)
                                  : 0
                              ) +
                                parseInt(
                                  item.sectors.displaced
                                    .displaced_individuals_accommodated
                                    ? item.sectors.displaced.displaced_individuals_accommodated
                                        .map(function(item) {
                                          return item.accomodated_females
                                            ? parseInt(item.accomodated_females)
                                            : 0;
                                        })
                                        .reduce((sum, value) => sum + value)
                                    : 0
                                )
                            )
                          }}
                        </td>
                      </tr>
                      <!-- start -->
                      <tr
                        v-if="
                          item.sectors.displaced.PeopleAffectedrows &&
                            item.sectors.displaced.PeopleAffectedrows.length > 0
                        "
                      >
                        <td
                          width="20%"
                          v-bind:rowspan="
                            item.sectors.displaced.PeopleAffectedrows.length
                              ? item.sectors.displaced.PeopleAffectedrows.length >
                                0
                                ? item.sectors.displaced.PeopleAffectedrows
                                    .length + 2
                                : 1
                              : 1
                          "
                          colspan="5"
                        >
                          <strong>Number of Households displaced</strong>
                        </td>
                        <td colspan="6">
                          <b>
                            <b>GVH</b>
                          </b>
                        </td>
                        <td colspan="2" width="8%">
                          <b>
                            <center>Male</center>
                          </b>
                        </td>
                        <td colspan="2" width="8%">
                          <b>
                            <center>Female</center>
                          </b>
                        </td>
                        <td colspan="2" width="8%" style="font-weight:bold">
                          <b>
                            <b>
                              <center>Total</center>
                            </b>
                          </b>
                        </td>
                      </tr>
                      <tr
                        v-if="
                          item.sectors.displaced.PeopleAffectedrows &&
                            item.sectors.displaced.PeopleAffectedrows.length > 0
                        "
                        v-for="row in item.sectors.displaced.PeopleAffectedrows"
                      >
                        <td colspan="6">{{ row.name }}</td>
                        <td colspan="2" class="right-align">
                          {{
                            numberWithCommas(row.number_displaced_by_gender_mhh)
                          }}
                        </td>
                        <td colspan="2" class="right-align">
                          {{
                            numberWithCommas(row.number_displaced_by_gender_fhh)
                          }}
                        </td>
                        <td
                          colspan="2"
                          style="font-weight:bold"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
                              (row.number_displaced_by_gender_fhh
                                ? parseInt(row.number_displaced_by_gender_fhh)
                                : 0) +
                                (row.number_displaced_by_gender_mhh
                                  ? parseInt(row.number_displaced_by_gender_mhh)
                                  : 0)
                            )
                          }}
                        </td>
                      </tr>
                      <tr
                        v-if="
                          item.sectors.displaced.PeopleAffectedrows &&
                            item.sectors.displaced.PeopleAffectedrows.length > 0
                        "
                      >
                        <td colspan="6" style="font-weight:bold">Total</td>
                        <td
                          colspan="2"
                          style="font-weight:bold"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
                              item.sectors.displaced.PeopleAffectedrows
                                ? item.sectors.displaced.PeopleAffectedrows.map(
                                    function(item) {
                                      return item.number_displaced_by_gender_mhh
                                        ? parseInt(
                                            item.number_displaced_by_gender_mhh
                                          )
                                        : 0;
                                    }
                                  ).reduce((sum, value) => sum + value)
                                : 0
                            )
                          }}
                        </td>
                        <td
                          colspan="2"
                          style="font-weight:bold"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
                              item.sectors.displaced.PeopleAffectedrows
                                ? item.sectors.displaced.PeopleAffectedrows.map(
                                    function(item) {
                                      return item.number_displaced_by_gender_fhh
                                        ? parseInt(
                                            item.number_displaced_by_gender_fhh
                                          )
                                        : 0;
                                    }
                                  ).reduce((sum, value) => sum + value)
                                : 0
                            )
                          }}
                        </td>
                        <td
                          colspan="2"
                          style="font-weight:bold"
                          class="right-align"
                        >
                          {{
                            numberWithCommas(
                              (item.sectors.displaced.PeopleAffectedrows
                                ? item.sectors.displaced.PeopleAffectedrows.map(
                                    function(item) {
                                      return item.number_displaced_by_gender_fhh
                                        ? parseInt(
                                            item.number_displaced_by_gender_fhh
                                          )
                                        : 0;
                                    }
                                  ).reduce((sum, value) => sum + value)
                                : 0) +
                                (item.sectors.displaced.PeopleAffectedrows
                                  ? item.sectors.displaced.PeopleAffectedrows.map(
                                      function(item) {
                                        return item.number_displaced_by_gender_mhh
                                          ? parseInt(
                                              item.number_displaced_by_gender_mhh
                                            )
                                          : 0;
                                      }
                                    ).reduce((sum, value) => sum + value)
                                  : 0)
                            )
                          }}
                        </td>
                      </tr>
                      <!-- end -->
                      <tr>
                        <td style="width:20%" colspan="5">
                          <strong>Response Needed</strong>
                        </td>
                        <td colspan="12" style="width:70%">
                          <u>
                          <strong>URGENT RESPONSE FOR NON FOOD ITEMS</strong>
                        </u>
                        <br />
                         <li
                          
                          style="margin-left: 2%"
                          class="qcont"
                          v-for="objct in item.sectors.displaced
                            .response_needed_non_food"
                          :key="objct"
                        >
                          <!-- {{
                            item.sectors.shelter
                              ? item.sectors.shelter.response_needed_non_food.name
                                ? item.sectors.shelter.response_needed_emergency
                                : "N/A"
                              : "N/A"
                          }} -->
                          {{ item.sectors.displaced
                            .response_needed_non_food.length > 0 ? objct.name : "NA" }} - {{objct.specification}}  
                        </li>
  
                        <hr style="margin: 1%" />
                         <u>
                          <strong>EMERGENCY RESPONSE</strong>
                        </u>
                        <br />
                        <li
                          style="margin-left: 2%"
                          class="qcont"
                          v-for="obj in item.sectors.displaced
                            .response_needed_emergency"
                          :key="obj"
                          
                        >
                          <!-- {{
                            item.sectors.shelter
                              ? item.sectors.shelter.response_needed_non_food.name
                                ? item.sectors.shelter.response_needed_emergency
                                : "N/A"
                              : "N/A"
                          }} -->
                          {{ item.sectors.displaced.response_needed_emergency.length > 0 ? obj.name : "NA"}}  {{  obj.specification  }}
                        </li>
                         <hr style="margin: 1%" />
                        <u>
                          <strong>GENERAL</strong>
                        </u>
                        <br />
                        <li style="margin-left: 2%" class="qcont">
                          {{
                            item.sectors.displaced
                              ? item.sectors.displaced.response_needed
                                ? item.sectors.displaced.response_needed
                                : "N/A"
                              : "N/A"
                          }}
                        </li>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
                <!-- end displaced -->
        <!--  agricultutre -->
        <tr
          v-if="item.sectors.agriculture"
          style="
                    margin: 0 !important;
                    padding: 0 !important;
                    border: 0px !important;
                  "
        >
          <td
            colspan="15"
            style="
                      margin: 0 !important;
                      padding: 0 !important;
                      border: 0px;
                    "
          >
            <table
              width="100%"
              style="
                        margin: 0 !important;
                        padding: 0 !important;
                        border: 0px;
                      "
            >
              <tr>
                <td
                  width="10%"
                  class="clearfix"
                  :rowspan="
                    (item.sectors.agriculture.impact_on_crops ? 1 : 1) +
                      (item.sectors.agriculture.crops_damaged
                        ? item.sectors.agriculture.crops_damaged.length >= 0
                          ? item.sectors.agriculture.crops_damaged.length + 2
                          : 1
                        : 1) +
                      (item.sectors.agriculture.impact_on_livestock
                        ? item.sectors.agriculture.impact_on_livestock.length > 0
                          ? 1
                          : 1
                        : 1) +
                      (item.sectors.agriculture.food_item_damage
                        ? item.sectors.agriculture.food_item_damage.length > 0
                          ? item.sectors.agriculture.food_item_damage.length + 1
                          : 1
                        : 1) +
                      1
                  "
                >
                  <span class="rotated" style="font-weight: bold"
                    ></span
                  >
                  <img
                    src="../../../../static/other_cluster_agriculture_100px_bluebox.png"
                    height="150"
                  />
                </td>
                <td
                  colspan="12"
                  width="80%"
                  v-if="item.sectors.agriculture.crops_damaged"
                >
                  <strong>Number of Crops damaged (Hectares)</strong>
                </td>
                <td
                  colspan="2"
                  width="10%"
                  v-if="item.sectors.agriculture.crops_damaged"
                  class="right-align"
                >
                  <span
                    v-if="
                      item.sectors.agriculture.crops_damaged &&
                        item.sectors.agriculture.crops_damaged.length > 0
                    "
                    class="right-align"
                  >
                    {{
                      numberWithCommas(
                        item.sectors.agriculture.crops_damaged
                          ? item.sectors.agriculture.crops_damaged
                              .map(function(item) {
                                return item.hectares_washed_away
                                  ? parseInt(item.hectares_washed_away)
                                  : 0;
                              })
                              .reduce((sum, value) => sum + value) +
                              item.sectors.agriculture.crops_damaged
                                .map(function(item) {
                                  return item.hectares_submerged
                                    ? parseInt(item.hectares_submerged)
                                    : 0;
                                })
                                .reduce((sum, value) => sum + value)
                          : 0
                      )
                    }}
                  </span>
                </td>
              </tr>
              <tr
                v-if="
                  item.sectors.agriculture.impact_on_crops ||
                    item.sectors.agriculture.impact_on_livestock
                "
              >
                <td colspan="12" width="80%">
                  <strong>Number of Households affected</strong>
                </td>
                <td colspan="2" width="10%" class="right-align">
                  <span
                    v-if="
                      item.sectors.agriculture.impact_on_crops &&
                        item.sectors.agriculture.impact_on_crops.length > 0
                    "
                    class="right-align"
                  >
                    {{
                      numberWithCommas(
                        item.sectors.agriculture.impact_on_crops
                          ? item.sectors.agriculture.impact_on_crops
                              .map(function(item) {
                                return item.hh_affected
                                  ? parseInt(item.hh_affected)
                                  : 0;
                              })
                              .reduce((sum, value) => sum + value)
                          : 0
                      )
                    }}
                  </span>
                </td>
              </tr>
              <tr v-if="item.sectors.agriculture.impact_on_livestock">
                <td colspan="12" width="80%">
                  <strong>Number of Livestock affected</strong>
                </td>
                <td colspan="2" width="10%" class="right-align">
                  <span
                    v-if="
                      item.sectors.agriculture.impact_on_livestock &&
                        item.sectors.agriculture.impact_on_livestock.length > 0
                    "
                    class="right-align"
                  >
                    {{
                      numberWithCommas(
                        item.sectors.agriculture.impact_on_livestock
                          ? item.sectors.agriculture.impact_on_livestock
                              .map(function(item) {
                                return item.livestock_affected
                                  ? parseInt(item.livestock_affected)
                                  : 0;
                              })
                              .reduce((sum, value) => sum + value)
                          : 0
                      )
                    }}
                  </span>
                </td>
              </tr>
  
              <tr
                v-if="
                  item.sectors.agriculture.crops_damaged &&
                    item.sectors.agriculture.crops_damaged.length > 0
                "
              >
                <td
                  v-bind:rowspan="
                    item.sectors.agriculture.crops_damaged
                      ? item.sectors.agriculture.crops_damaged.length + 1
                      : 1
                  "
                  colspan="5"
                  width="20%"
                >
                  <strong>Damage per crop (Hectares)</strong>
                </td>
                <td colspan="3" width="40%">
                  <b>Name</b>
                </td>
                <td colspan="2" width="10%">
                  <b>Submerged</b>
                </td>
                <td colspan="2" width="10%">
                  <b>Washed away</b>
                </td>
                <td colspan="2" width="10%">
                  <b>
                    <center>Total</center>
                  </b>
                </td>
              </tr>
              <tr
                v-if="
                  item.sectors.agriculture.crops_damaged &&
                    item.sectors.agriculture.crops_damaged.length > 0
                "
                v-for="crop in item.sectors.agriculture.crops_damaged"
              >
                <td colspan="3" width="40%">{{ crop.name }}</td>
                <td width="10%" colspan="2" class="right-align">
                  {{ numberWithCommas(crop.hectares_submerged) }}
                </td>
                <td width="10%" colspan="2" class="right-align">
                  {{ numberWithCommas(crop.hectares_washed_away) }}
                </td>
                <td width="10%" colspan="2" class="right-align">
                  {{
                    numberWithCommas(
                      (crop.hectares_submerged
                        ? parseInt(crop.hectares_submerged)
                        : 0) +
                        (crop.hectares_washed_away
                          ? parseInt(crop.hectares_washed_away)
                          : 0)
                    )
                  }}
                </td>
              </tr>
  
              <tr
                v-if="
                  item.sectors.agriculture.food_item_damage &&
                    item.sectors.agriculture.food_item_damage.length > 0
                "
              >
                <td
                  v-bind:rowspan="
                    item.sectors.agriculture.food_item_damage.length + 1
                  "
                  colspan="5"
                  width="20%"
                >
                  <strong>Number of Food items damage (KGs)</strong>
                </td>
                <td colspan="7" width="60%">
                  <b>Name</b>
                </td>
                <td colspan="2" width="10%">
                  <b>in KGs</b>
                </td>
              </tr>
              <tr
                v-if="
                  item.sectors.agriculture.food_item_damage &&
                    item.sectors.agriculture.food_item_damage.length > 0
                "
                v-for="crop in item.sectors.agriculture.food_item_damage"
              >
                <td colspan="7" width="60%">{{ crop.food_item_name }}</td>
                <td colspan="2" width="10%" class="right-align">
                  {{ numberWithCommas(crop.number_of_kilos) }}
                </td>
              </tr>
              <tr>
                <td colspan="5" style="width: 20%">
                  <strong>Response Needed</strong>
                </td>
                <td colspan="9" style="width: 70%">
                  <u>
                    <strong>URGENT</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.agriculture
                        ? item.sectors.agriculture.urgent_response_needed
                          ? item.sectors.agriculture.urgent_response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                  <hr style="margin: 1%" />
                  <u>
                    <strong>GENERAL</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.agriculture
                        ? item.sectors.agriculture.response_needed
                          ? item.sectors.agriculture.response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- end agricultutre -->
        <!--  Food security -->
        <tr
          v-if="item.sectors.food"
          style="margin: 0; padding: 0 !important; border: 0px !important"
        >
          <td colspan="15" style="margin: 0; padding: 0 !important; border: 0px">
            <table
              width="100%"
              style="
                        margin: 0;
                        padding: 0 !important;
                        border: 0px !important;
                      "
            >
              <tr>
                <td
                  :rowspan="
                    item.sectors.food.food_stocks_avaliability
                      ? item.sectors.food.food_stocks_avaliability.length + 3
                      : 2
                  "
                  width="10%"
                  class="clearfix"
                >
                  <span class="rotated" style="font-weight: bold"
                    ></span
                  >
                  <img
                    src="../../../../static/cluster_food_security_100px_bluebox.png"
                    height="150"
                  />
                </td>
                <td
                  v-if="
                    item.sectors.food.food_stocks_avaliability &&
                      item.sectors.food.food_stocks_avaliability.length > 0
                  "
                  v-bind:rowspan="
                    item.sectors.food.food_stocks_avaliability.length > 0
                      ? item.sectors.food.food_stocks_avaliability.length + 1
                      : 1
                  "
                  colspan="6"
                  style="width: 20%"
                >
                  <strong>Food stocks availability (HH)</strong>
                </td>
                <td
                  colspan="2"
                  width="40%"
                  v-if="
                    item.sectors.food.food_stocks_avaliability &&
                      item.sectors.food.food_stocks_avaliability.length > 0
                  "
                >
                  <b>Category</b>
                </td>
                <td
                  width="10%"
                  colspan="2"
                  v-if="
                    item.sectors.food.food_stocks_avaliability &&
                      item.sectors.food.food_stocks_avaliability.length > 0
                  "
                >
                  <b>
                    <center>Male</center>
                  </b>
                </td>
                <td
                  width="10%"
                  colspan="2"
                  v-if="
                    item.sectors.food.food_stocks_avaliability &&
                      item.sectors.food.food_stocks_avaliability.length > 0
                  "
                >
                  <b>
                    <center>Female</center>
                  </b>
                </td>
                <td
                  width="10%"
                  colspan="2"
                  v-if="
                    item.sectors.food.food_stocks_avaliability &&
                      item.sectors.food.food_stocks_avaliability.length > 0
                  "
                >
                  <b>
                    <center>Total</center>
                  </b>
                </td>
              </tr>
              <tr
                v-if="
                  item.sectors.food.food_stocks_avaliability &&
                    item.sectors.food.food_stocks_avaliability.length > 0
                "
                v-for="crop in item.sectors.food.food_stocks_avaliability"
              >
                <td colspan="2" class="clearfix" width="40%">
                  {{ crop.category }}
                </td>
                <td colspan="2" width="10%" class="right-align">
                  {{ numberWithCommas(crop.male_HH) }}
                </td>
                <td colspan="2" width="10%" class="right-align">
                  {{ numberWithCommas(crop.female_HH) }}
                </td>
                <td colspan="2" width="10%" class="right-align">
                  {{
                    numberWithCommas(
                      parseInt(crop.male_HH) + parseInt(crop.female_HH)
                    )
                  }}
                </td>
              </tr>
              <tr v-if="item.sectors.food">
                <td colspan="6" style="width: 20%">
                  <strong>Response Needed</strong>
                </td>
                <td colspan="9" style="width: 80%">
                  <u>
                    <strong>URGENT</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.food
                        ? item.sectors.food.urgent_response_needed
                          ? item.sectors.food.urgent_response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                  <hr style="margin: 1%" />
                  <u>
                    <strong>GENERAL</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.food
                        ? item.sectors.food.response_needed
                          ? item.sectors.food.response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- end Food security -->
        <!--  Education-->
        <tr
          v-if="item.sectors.education"
          style="margin: 0; padding: 0 !important; border: 0px !important"
        >
          <td colspan="15" style="margin: 0; padding: 0 !important; border: 0px">
            <table
              width="100%"
              style="
                        margin: 0;
                        padding: 0 !important;
                        border: 0px !important;
                      "
            >
              <tr>
                <td
                  :rowspan="
                    4 +
                      (item.sectors.education.impact_on_schools
                        ? item.sectors.education.impact_on_schools.length +
                          item.sectors.education.impact_on_schools.length
                        : 0)
                  "
                  width="10%"
                  class="clearfix"
                >
                  <span class="rotated" style="font-weight: bold"></span>
                  <img
                    src="../../../../static/cluster_education_100px_bluebox.png"
                    height="150"
                  />
                </td>
                <td
                  v-if="
                    item.sectors.education.impact_on_schools &&
                      item.sectors.education.impact_on_schools.length > 0
                  "
                  :rowspan="1 + item.sectors.education.impact_on_schools.length"
                  colspan="4"
                  style="20%"
                >
                  <b>Impact on schools buildings</b>
                </td>
                <td
                  v-if="
                    item.sectors.education.impact_on_schools &&
                      item.sectors.education.impact_on_schools.length > 0
                  "
                  width="10%"
                >
                  <b>School type</b>
                </td>
                <td
                  v-if="
                    item.sectors.education.impact_on_schools &&
                      item.sectors.education.impact_on_schools.length > 0
                  "
                  width="10%"
                >
                  <b>Structure type</b>
                </td>
                <td
                  v-if="
                    item.sectors.education.impact_on_schools &&
                      item.sectors.education.impact_on_schools.length > 0
                  "
                  width="10%"
                >
                  <b>Name</b>
                </td>
                <td
                  v-if="
                    item.sectors.education.impact_on_schools &&
                      item.sectors.education.impact_on_schools.length > 0
                  "
                  width="10%"
                >
                  <b>Roof affected</b>
                </td>
                <td
                  v-if="
                    item.sectors.education.impact_on_schools &&
                      item.sectors.education.impact_on_schools.length > 0
                  "
                  width="10%"
                >
                  <b>Under water</b>
                </td>
                <td
                  v-if="
                    item.sectors.education.impact_on_schools &&
                      item.sectors.education.impact_on_schools.length > 0
                  "
                  width="10%"
                >
                  <b>Partly damaged</b>
                </td>
  
                <td
                  v-if="
                    item.sectors.education.impact_on_schools &&
                      item.sectors.education.impact_on_schools.length > 0
                  "
                  width="10%"
                >
                  <b>Completely damaged</b>
                </td>
              </tr>
  
              <tr
                v-if="
                  item.sectors.education.impact_on_schools &&
                    item.sectors.education.impact_on_schools.length > 0
                "
                v-for="row in item.sectors.education.impact_on_schools"
              >
                <td width="10%">{{ row.school_type }}</td>
                <td width="10%">{{ row.structure_type }}</td>
                <td width="10%">{{ row.school_name }}</td>
                <td width="10%" class="right-align">
                  {{ numberWithCommas(row.roofs_affected) }}
                </td>
                <td width="10%" class="right-align">
                  {{ numberWithCommas(row.underwater) }}
                </td>
                <td width="10%" class="right-align">
                  {{ numberWithCommas(row.partially_functioning) }}
                </td>
                <td width="10%" class="right-align">
                  {{ numberWithCommas(row.completely_damaged) }}
                </td>
              </tr>
              <tr
                v-if="
                  item.sectors.education.impact_on_schools &&
                    item.sectors.education.impact_on_schools.length > 0
                "
              >
                <td
                  v-if="item.sectors.education.impact_on_schools"
                  :rowspan="1 + item.sectors.education.impact_on_schools.length"
                  colspan="7"
                  style="20%"
                >
                  <b>Impact on school goers</b>
                </td>
                <td v-if="item.sectors.education.impact_on_schools" width="10%">
                  <b>School type</b>
                </td>
                <td v-if="item.sectors.education.impact_on_schools" width="10%">
                  <b>Name</b>
                </td>
                <td v-if="item.sectors.education.impact_on_schools" width="10%">
                  <b>Males out of school</b>
                </td>
                <td v-if="item.sectors.education.impact_on_schools" width="10%">
                  <b>Females out of school</b>
                </td>
              </tr>
              <tr
                v-if="
                  item.sectors.education.impact_on_schools &&
                    item.sectors.education.impact_on_schools.length > 0
                "
                v-for="row in item.sectors.education.impact_on_schools"
              >
                <td width="10%">{{ row.school_type }}</td>
                <td width="10%">{{ row.school_name }}</td>
                <td width="10%" class="right-align">
                  {{ numberWithCommas(row.females_out_of_school) }}
                </td>
                <td width="10%" class="right-align">
                  {{ numberWithCommas(row.males_out_of_school) }}
                </td>
              </tr>
              <tr>
                <td colspan="2" style="width: 20%">
                  <strong>Response Needed</strong>
                </td>
                <td colspan="12">
                  <u>
                    <strong>URGENT</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.education
                        ? item.sectors.education.urgent_response_needed
                          ? item.sectors.education.urgent_response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                  <hr style="margin: 1%" />
                  <u>
                    <strong>GENERAL</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.education
                        ? item.sectors.education.response_needed
                          ? item.sectors.education.response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- end Education -->
        <!--  Healthy -->
        <tr
          v-if="item.sectors.health"
          style="margin: 0; padding: 0 !important; border: 0px !important"
        >
          <td colspan="15" style="margin: 0; padding: 0 !important; border: 0px">
            <table
              width="100%"
              style="
                        margin: 0;
                        padding: 0 !important;
                        border: 0px !important;
                      "
            >
              <tr>
                <td
                  :rowspan="
                    (item.sectors.health.available_health_facilities
                      ? item.sectors.health.available_health_facilities.length
                      : 0) +
                      (item.sectors.health.risk_out_disease_outbreak
                        ? item.sectors.health.risk_out_disease_outbreak.length + 1
                        : 0) +
                      2
                  "
                  width="10%"
                  class="clearfix"
                >
                  <span class="rotated" style="font-weight: bold"
                    ></span
                  >
                  <img
                    src="../../../../static/cluster_health_100px_bluebox.png"
                    height="150"
                  />
                </td>
                <td
                  v-if="
                    item.sectors.health.available_health_facilities &&
                      item.sectors.health.available_health_facilities.length > 0
                  "
                  :rowspan="
                    1 + item.sectors.health.available_health_facilities.length
                  "
                  colspan="6"
                  style="width: 20%"
                >
                  <strong>Health facility availability</strong>
                </td>
                <td
                  style="width: 40%"
                  colspan="2"
                  v-if="
                    item.sectors.health.available_health_facilities &&
                      item.sectors.health.available_health_facilities.length > 0
                  "
                >
                  <b>Health facility available</b>
                </td>
                <td
                  style="width: 10%"
                  v-if="
                    item.sectors.health.available_health_facilities &&
                      item.sectors.health.available_health_facilities.length > 0
                  "
                  colspan="2"
                >
                  <b>Partly functioning</b>
                </td>
                <td
                  style="width: 10%"
                  v-if="
                    item.sectors.health.available_health_facilities &&
                      item.sectors.health.available_health_facilities.length > 0
                  "
                  colspan="2"
                >
                  <b>Verge of closing</b>
                </td>
                <td
                  style="width: 10%"
                  v-if="
                    item.sectors.health.available_health_facilities &&
                      item.sectors.health.available_health_facilities.length > 0
                  "
                  colspan="2"
                >
                  <b>Closed</b>
                </td>
              </tr>
              <tr
                v-if="
                  item.sectors.health.available_health_facilities &&
                    item.sectors.health.available_health_facilities.length > 0
                "
                v-for="row in item.sectors.health.available_health_facilities"
              >
                <td style="width: 40%" colspan="2">{{ row.name }}</td>
                <td style="width: 10%" colspan="2" class="right-align">
                  {{ numberWithCommas(row.partially_functioning) }}
                </td>
                <td style="width: 10%" colspan="2" class="right-align">
                  {{ numberWithCommas(row.verge_of_closing) }}
                </td>
                <td style="width: 10%" colspan="2" class="right-align">
                  {{ numberWithCommas(row.closed) }}
                </td>
              </tr>
              <tr
                v-if="
                  item.sectors.health.risk_out_disease_outbreak &&
                    item.sectors.health.risk_out_disease_outbreak.length > 0
                "
              >
                <td
                  :rowspan="
                    1 + item.sectors.health.risk_out_disease_outbreak.length
                  "
                  colspan="6"
                  style="width: 20%"
                >
                  <strong>Risks of disease outbreak</strong>
                </td>
                <td colspan="2" style="width: 40%">
                  <b>Disease</b>
                </td>
                <td colspan="6" style="width: 30%">
                  <b>Risk</b>
                </td>
              </tr>
              <tr
                v-if="
                  item.sectors.health.risk_out_disease_outbreak &&
                    item.sectors.health.risk_out_disease_outbreak.length > 0
                "
                v-for="row in item.sectors.health.risk_out_disease_outbreak"
              >
                <td style="width: 40%" colspan="2">{{ row.name }}</td>
                <td style="width: 30%" colspan="6">{{ row.risk }}</td>
              </tr>
  
              <tr v-if="item.sectors.health">
                <td colspan="6" style="width: 20%">
                  <strong>Response Needed</strong>
                </td>
                <td colspan="8" style="width: 70%">
                  <u>
                    <strong>URGENT</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.health
                        ? item.sectors.health.urgent_response_needed
                          ? item.sectors.health.urgent_response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                  <hr style="margin: 1%" />
                  <u>
                    <strong>GENERAL</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.health
                        ? item.sectors.health.response_needed
                          ? item.sectors.health.response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- end Healthy -->
        <!-- Food livelihoods -->
        <tr
          v-if="item.sectors.livelihoods"
          style="margin: 0; padding: 0 !important; border: 0px !important"
        >
          <td colspan="15" style="margin: 0; padding: 0 !important; border: 0px">
            <table
              width="100%"
              style="
                        margin: 0;
                        padding: 0 !important;
                        border: 0px !important;
                      "
            >
              <tr>
                <td
                  width="10%"
                  class="clearfix"
                  :rowspan="
                    item.sectors.livelihoods.livelihoods_affected
                      ? item.sectors.livelihoods.livelihoods_affected.length + 2
                      : 2
                  "
                >
                  <span class="rotated" style="font-weight: bold"
                    ></span
                  >
                  <img
                    src="../../../../static/socioeconomic_livelihood_100px_bluebox.png"
                    height="150"
                  />
                </td>
                <td
                  v-if="
                    item.sectors.livelihoods.livelihoods_affected &&
                      item.sectors.livelihoods.livelihoods_affected.length > 0
                  "
                  :rowspan="
                    1 + item.sectors.livelihoods.livelihoods_affected.length
                  "
                  style="width: 20%"
                >
                  <strong>Livelihoods affected (HH)</strong>
                </td>
                <td
                  width="50%"
                  v-if="
                    item.sectors.livelihoods.livelihoods_affected &&
                      item.sectors.livelihoods.livelihoods_affected.length > 0
                  "
                  colspan="8"
                >
                  <b>Category</b>
                </td>
                <td
                  width="10%"
                  v-if="
                    item.sectors.livelihoods.livelihoods_affected &&
                      item.sectors.livelihoods.livelihoods_affected.length > 0
                  "
                  colspan="2"
                >
                  <b>Severely affected</b>
                </td>
                <td
                  width="10%"
                  v-if="
                    item.sectors.livelihoods.livelihoods_affected &&
                      item.sectors.livelihoods.livelihoods_affected.length > 0
                  "
                  colspan="2"
                >
                  <b>Slightly affected</b>
                </td>
              </tr>
              <tr
                v-if="
                  item.sectors.livelihoods.livelihoods_affected &&
                    item.sectors.livelihoods.livelihoods_affected.length > 0
                "
                v-for="row in item.sectors.livelihoods.livelihoods_affected"
              >
                <td width="50%" colspan="8">{{ row.name }}</td>
                <td width="10%" colspan="2" class="right-align">
                  {{ numberWithCommas(row.severely_affected) }}
                </td>
                <td width="10%" colspan="2" class="right-align">
                  {{ numberWithCommas(row.slightly_affected) }}
                </td>
              </tr>
              <tr>
                <td colspan="1" style="width: 20%">
                  <strong>Response Needed</strong>
                </td>
                <td colspan="13" style="width: 70%">
                  <u>
                    <strong>URGENT</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.livelihoods
                        ? item.sectors.livelihoods.urgent_response_needed
                          ? item.sectors.livelihoods.urgent_response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                  <hr style="margin: 1%" />
                  <u>
                    <strong>GENERAL</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.livelihoods
                        ? item.sectors.livelihoods.response_needed
                          ? item.sectors.livelihoods.response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- end livelihoods -->
        <!--  Nutrition -->
        <tr
          v-if="item.sectors.nutrition"
          style="margin: 0; padding: 0 !important; border: 0px !important"
        >
          <td colspan="15" style="margin: 0; padding: 0 !important; border: 0px">
            <table
              width="100%"
              style="
                        margin: 0;
                        padding: 0 !important;
                        border: 0px !important;
                      "
            >
              <tr>
                <td
                  :rowspan="
                    3 +
                      (item.sectors.nutrition.affected_population
                        ? item.sectors.nutrition.affected_population.length
                        : 0) +
                      (item.sectors.nutrition.impact_on_nutrition_programmes
                        ? item.sectors.nutrition.impact_on_nutrition_programmes
                            .length
                        : 0)
                  "
                  width="10%"
                  class="clearfix"
                >
                  <span class="rotated" style="font-weight: bold"></span>
                  <img
                    src="../../../../static/cluster_nutrition_100px_bluebox.png"
                    height="150"
                  />
                </td>
                <td
                  v-if="item.sectors.nutrition.affected_population"
                  width="20%"
                  :rowspan="1 + item.sectors.nutrition.affected_population.length"
                  colspan="4"
                >
                  <strong>Affected Population</strong>
                </td>
                <td colspan="4" width="40%">
                  <b>Category</b>
                </td>
                <td colspan="2" width="10%">
                  <b>
                    <center>Male</center>
                  </b>
                </td>
                <td colspan="2" width="10%">
                  <b>
                    <center>Female</center>
                  </b>
                </td>
                <td colspan="2" width="10%">
                  <b>
                    <center>Total</center>
                  </b>
                </td>
              </tr>
              <tr
                v-if="item.sectors.nutrition.affected_population"
                v-for="row in item.sectors.nutrition.affected_population"
              >
                <td colspan="4" width="40%">{{ row.name }}</td>
                <td colspan="2" width="10%" class="right-align">
                  {{ numberWithCommas(row.affected_males) }}
                </td>
                <td colspan="2" width="10%" class="right-align">
                  {{ numberWithCommas(row.affected_females) }}
                </td>
                <td colspan="2" width="10%" class="right-align">
                  {{
                    numberWithCommas(
                      parseInt(row.affected_females) +
                        parseInt(row.affected_males)
                    )
                  }}
                </td>
              </tr>
  
              <tr v-if="item.sectors.nutrition.impact_on_nutrition_programmes">
                <td
                  :rowspan="
                    1 +
                      item.sectors.nutrition.impact_on_nutrition_programmes.length
                  "
                  colspan="4"
                  width="20%"
                >
                  <strong>Impact on nutrition programmes</strong>
                </td>
                <td colspan="4">
                  <b>Category</b>
                </td>
                <td colspan="6">
                  <b>Status</b>
                </td>
              </tr>
              <tr
                v-if="item.sectors.nutrition.impact_on_nutrition_programmes"
                v-for="row in item.sectors.nutrition
                  .impact_on_nutrition_programmes"
              >
                <td colspan="4">{{ row.name }}</td>
                <td colspan="6">{{ row.status }}</td>
              </tr>
  
              <tr v-if="item.sectors.nutrition.impact_on_nutrition_programmes">
                <td colspan="4" style="width: 20%">
                  <strong>Response Needed</strong>
                </td>
                <td colspan="10" style="width: 70%">
                  <u>
                    <strong>URGENT</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.nutrition
                        ? item.sectors.nutrition.urgent_response_needed
                          ? item.sectors.nutrition.urgent_response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                  <hr style="margin: 1%" />
                  <u>
                    <strong>GENERAL</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.nutrition
                        ? item.sectors.nutrition.response_needed
                          ? item.sectors.nutrition.response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- end Nutrition -->
        <!--  Protection -->
        <tr
          v-if="item.sectors.protection"
          style="margin: 0; padding: 0 !important; border: 0px !important"
        >
          <td colspan="15" style="margin: 0; padding: 0 !important; border: 0px">
            <table
              width="100%"
              style="
                        margin: 0;
                        padding: 0 !important;
                        border: 0px !important;
                      "
            >
              <tr v-if="item.sectors.protection.impact_on_vulnerable_persons">
                <td
                  :rowspan="
                    2 +
                      item.sectors.protection.impact_on_vulnerable_persons.length
                  "
                  width="10%"
                  class="clearfix"
                >
                  <span class="rotated" style="font-weight: bold"
                    ></span
                  >
                  <img
                    src="../../../../static/cluster_protection_100px_bluebox.png"
                    height="150"
                  />
                </td>
                <td
                  :rowspan="
                    1 +
                      item.sectors.protection.impact_on_vulnerable_persons.length
                  "
                  width="20%"
                >
                  <strong>Impact on vulnerable population</strong>
                </td>
                <td colspan="7" width="40%">
                  <b>Group affected</b>
                </td>
                <td colspan="2" width="10%">
                  <b>
                    <center>Male</center>
                  </b>
                </td>
                <td colspan="2" width="10%">
                  <b>
                    <center>Female</center>
                  </b>
                </td>
                <td colspan="2" width="10%">
                  <b>
                    <center>Total</center>
                  </b>
                </td>
              </tr>
              <tr
                v-if="item.sectors.protection.impact_on_vulnerable_persons"
                v-for="row in item.sectors.protection
                  .impact_on_vulnerable_persons"
              >
                <td colspan="7" width="40%">{{ row.name }}</td>
                <td colspan="2" width="10%" class="right-align">
                  {{ numberWithCommas(row.impacted_males) }}
                </td>
                <td colspan="2" width="10%" class="right-align">
                  {{ numberWithCommas(row.impacted_females) }}
                </td>
                <td colspan="2" width="10%" class="right-align">
                  {{
                    numberWithCommas(
                      (row.impacted_females
                        ? parseInt(row.impacted_females)
                        : 0) +
                        (row.impacted_males ? parseInt(row.impacted_males) : 0)
                    )
                  }}
                </td>
              </tr>
              <tr v-if="item.sectors.protection.impact_on_vulnerable_persons">
                <td style="width: 20%">
                  <strong>Response Needed</strong>
                </td>
                <td colspan="13" style="width: 70%">
                  <u>
                    <strong>URGENT</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.protection
                        ? item.sectors.protection.urgent_response_needed
                          ? item.sectors.protection.urgent_response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                  <hr style="margin: 1%" />
                  <u>
                    <strong>GENERAL</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.protection
                        ? item.sectors.protection.response_needed
                          ? item.sectors.protection.response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- end Protection -->
        <!--  Wash -->
        <tr
          v-if="item.sectors.wash"
          style="margin: 0; padding: 0 !important; border: 0px !important"
        >
          <td colspan="15" style="margin: 0; padding: 0 !important; border: 0px">
            <table
              width="100%"
              style="
                        margin: 0;
                        padding: 0 !important;
                        border: 0px !important;
                      "
            >
              <tr v-if="item.sectors.wash">
                <td
                  :rowspan="
                    4 +
                      (item.sectors.wash.risk_of_water_contamination
                        ? item.sectors.wash.risk_of_water_contamination.length + 2
                        : 2)
                  "
                  width="10%"
                  class="clearfix"
                >
                  <span class="rotated" style="font-weight: bold"></span>
                  <img
                    src="../../../../static/cluster_WASH_100px_bluebox.png"
                    height="150"
                  />
                </td>
                <td
                  :rowspan="
                    item.sectors.wash.risk_of_water_contamination
                      ? item.sectors.wash.risk_of_water_contamination.length + 1
                      : 1
                  "
                  colspan="5"
                  style="width: 20%"
                >
                  <b>Risk of contamination</b>
                </td>
                <td colspan="5">
                  <b>Source</b>
                </td>
                <td colspan="4">
                  <b>Risk</b>
                </td>
              </tr>
              <tr
                v-if="item.sectors.wash.risk_of_water_contamination"
                v-for="row in item.sectors.wash.risk_of_water_contamination"
              >
                <td colspan="5">{{ row.source }}</td>
                <td colspan="5">{{ row.risk }}</td>
              </tr>
  
              <tr
                v-if="
                  item.sectors.wash.with_safe_water_fhh ||
                    item.sectors.wash.with_safe_water_mhh
                "
              >
                <td style="width: 20%" rowspan="2" colspan="5">
                  <b>Households without access to toilets</b>
                </td>
                <td colspan="3">
                  <b>
                    <center>Male</center>
                  </b>
                </td>
                <td colspan="3">
                  <b>
                    <center>Female</center>
                  </b>
                </td>
                <td colspan="3">
                  <b>
                    <center>Total</center>
                  </b>
                </td>
              </tr>
              <tr
                v-if="
                  item.sectors.wash.with_safe_water_fhh ||
                    item.sectors.wash.with_safe_water_mhh
                "
              >
                <td colspan="3" class="right-align">
                  {{ numberWithCommas(item.sectors.wash.with_safe_water_fhh) }}
                </td>
                <td colspan="3" class="right-align">
                  {{ numberWithCommas(item.sectors.wash.with_safe_water_mhh) }}
                </td>
                <td colspan="3" class="right-align">
                  {{
                    numberWithCommas(
                      item.sectors.wash.with_safe_water_mhh ||
                        item.sectors.wash.with_safe_water_fhh
                        ? parseInt(
                            item.sectors.wash.with_safe_water_mhh
                              ? item.sectors.wash.with_safe_water_mhh
                              : 0
                          ) +
                            parseInt(
                              item.sectors.wash.with_safe_water_fhh
                                ? item.sectors.wash.with_safe_water_fhh
                                : 0
                            )
                        : 0
                    )
                  }}
                </td>
              </tr>
  
              <tr v-if="item.sectors.wash.risk_contamination_mhh">
                <td style="width: 20%" rowspan="2" colspan="5">
                  Households with risk of contamination
                </td>
                <td colspan="3">
                  <b>
                    <center>Male</center>
                  </b>
                </td>
                <td colspan="3">
                  <b>
                    <center>Female</center>
                  </b>
                </td>
                <td colspan="3">
                  <b>
                    <center>Total</center>
                  </b>
                </td>
              </tr>
              <tr v-if="item.sectors.wash.risk_contamination_mhh">
                <td colspan="3" class="right-align">
                  {{ numberWithCommas(item.sectors.wash.risk_contamination_mhh) }}
                </td>
                <td colspan="3" class="right-align">
                  {{ numberWithCommas(item.sectors.wash.risk_contamination_fhh) }}
                </td>
                <td colspan="3" class="right-align">
                  {{
                    numberWithCommas(
                      parseInt(item.sectors.wash.risk_contamination_mhh) +
                        parseInt(item.sectors.wash.risk_contamination_fhh)
                        ? parseInt(item.sectors.wash.risk_contamination_mhh) +
                            parseInt(item.sectors.wash.risk_contamination_fhh)
                        : ""
                    )
                  }}
                </td>
              </tr>
  
              <tr>
                <td colspan="5" style="width: 20%">
                  <strong>Response Needed</strong>
                </td>
                <td colspan="9">
                  <u>
                    <strong>URGENT</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.wash
                        ? item.sectors.wash.urgent_response_needed
                          ? item.sectors.wash.urgent_response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                  <hr style="margin: 1%" />
                  <u>
                    <strong>GENERAL</strong>
                  </u>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.wash
                        ? item.sectors.wash.response_needed
                          ? item.sectors.wash.response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- end Wash -->
      <!--  Logisticts -->
                <tr
                  v-if="item.sectors.logistics"
                  style="margin:0;padding:0 !important;border:0px !important;"
                >
                  <td
                    colspan="15"
                    style="margin:0;padding:0 !important;border:0px"
                  >
                    <table
                      width="100%"
                      style="margin:0;padding:0 !important;border:0px !important;"
                    >
                      <tr>
                        <td
                          :rowspan="
                            2 +
                              (item.sectors.logistics.impacted_structures
                                ? item.sectors.logistics.impacted_structures
                                    .length
                                : 0)
                          "
                          width="10%"
                          class="clearfix"
                        >
                          <span class="rotated" style="font-weight: bold;"
                            ></span
                          >
                          <img
                            src="../../../../static/cluster_logistics_100px_bluebox.png"
                            height="150"
                          />
                        </td>
                        <!-- structures start -->
                        <td
                          v-if="item.sectors.logistics.impacted_structures"
                          :rowspan="
                            1 + item.sectors.logistics.impacted_structures.length
                          "
                          colspan="4"
                          style="width:20%"
                        >
                          <strong>Impact on infrastures</strong>
                        </td>
                        <td
                          colspan="5"
                          v-if="item.sectors.logistics.impacted_structures"
                          style="width:20%"
                        >
                          <b>Category</b>
                        </td>
                        <td
                          colspan="5"
                          v-if="item.sectors.logistics.impacted_structures"
                          style="width:20%"
                        >
                          <b>Road name</b>
                        </td>
                        <td
                          v-if="item.sectors.logistics.impacted_structures"
                          colspan="5"
                          style="width:15%"
                        >
                          <b>Latitude</b>
                        </td>
                        <td
                          v-if="item.sectors.logistics.impacted_structures"
                          colspan="5"
                          style="width:15%"
                        >
                          <b>Longitude</b>
                        </td>
                      </tr>
                      <tr
                        v-if="item.sectors.logistics.impacted_structures"
                        v-for="row in item.sectors.logistics.impacted_structures"
                      >
                        <td colspan="5" style="width:20%">{{ row.name }}</td>
                        <td colspan="5" style="width:20%">{{ row.road_name }}</td>
                        <td colspan="5" style="width:15%">{{ row.gps_lat }}</td>
                        <td colspan="5" style="width:15%">{{ row.gps_lng }}</td>
                      </tr>
                      <!-- structures end  -->
                      <tr>
                        <td colspan="4" style="width:20%">
                          <strong>Response Needed</strong>
                        </td>
                        <td colspan="16" style="width:70%">
                          <u>
                            <strong>URGENT</strong>
                          </u>
                          <br />
                          <li style="margin-left:2%" class="qcont">
                            {{
                              item.sectors.logistics
                                ? item.sectors.logistics.urgent_response_needed
                                  ? item.sectors.logistics.urgent_response_needed
                                  : "N/A"
                                : "N/A"
                            }}
                          </li>
                          <hr style="margin:1%;" />
                          <u>
                            <strong>GENERAL</strong>
                          </u>
                          <br />
                          <li style="margin-left:2%" class="qcont">
                            {{
                              item.sectors.logistics
                                ? item.sectors.logistics.response_needed
                                  ? item.sectors.logistics.response_needed
                                  : "N/A"
                                : "N/A"
                            }}
                          </li>
                        </td>
                      </tr>
  
                    </table>
                  </td>
                </tr>
                <!-- end Logisticts -->
        <!--  Environment -->
        <tr
          v-if="item.sectors.environment"
          style="margin: 0; padding: 0 !important; border: 0px !important"
        >
          <td colspan="15" style="margin: 0; padding: 0 !important; border: 0px">
            <table
              width="100%"
              style="
                        margin: 0;
                        padding: 0 !important;
                        border: 0px !important;
                      "
            >
              <tr>
                <td
                  :rowspan="
                    3 +
                      (item.sectors.environment.impact_on_environment
                        ? item.sectors.environment.impact_on_environment.length
                        : 0)
                  "
                  width="10%"
                  class="clearfix"
                >
                  <span class="rotated" style="font-weight: bold"
                    ></span
                  >
                  <img
                    src="../../../../static/other_cluster_environment_100px_bluebox.png"
                    height="150"
                  />
                </td>
                <td
                  v-if="item.sectors.environment.impact_on_environment"
                  :rowspan="
                    1 + item.sectors.environment.impact_on_environment.length
                  "
                  colspan="3"
                  style="width: 20%"
                >
                  <strong>Impact on structures</strong>
                </td>
                <td
                  v-if="item.sectors.environment.impact_on_environment"
                  colspan="9"
                  style="width: 60%"
                >
                  <b>Question</b>
                </td>
                <td
                  v-if="item.sectors.environment.impact_on_environment"
                  colspan="2"
                  width="10%"
                >
                  <b>Response</b>
                </td>
              </tr>
              <tr
                v-if="item.sectors.environment.impact_on_environment"
                v-for="row in item.sectors.environment.impact_on_environment"
              >
                <td colspan="9" style="width: 60%">
                  {{ row.impact_question }}
                </td>
                <td colspan="2" width="10%">{{ row.response }}</td>
              </tr>
              <tr>
                <td colspan="3" style="width: 20%">
                  <strong>Response Needed</strong>
                </td>
                <td colspan="11">
                  <b style="padding-bottom: 20px">
                    <u>
                      <strong>URGENT</strong>
                    </u>
                  </b>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.environment
                        ? item.sectors.environment.urgent_response_needed
                          ? item.sectors.environment.urgent_response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                  <hr style="margin: 1%" />
                  <b style="padding-bottom: 20px">
                    <u>
                      <strong>GENERAL</strong>
                    </u>
                  </b>
                  <br />
                  <li style="margin-left: 2%" class="qcont">
                    {{
                      item.sectors.environment
                        ? item.sectors.environment.response_needed
                          ? item.sectors.environment.response_needed
                          : "N/A"
                        : "N/A"
                    }}
                  </li>
                </td>
              </tr>
            </table>
          </td>
        </tr>
        <!-- end Environment -->
      </table>
    </div>
  </template>
<script>
import { MongoReports } from "../api/MongoReports";
import downloadexcel from "vue-json-excel";
import html2pdf from "html2pdf.js"
import EventBus from "../../../helpers/event-bus"
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import moment from "moment";
var QRCode = require("qrcode");
import DetailedHeader from "./detailedReportHeader.vue";
import ReviewBody from "./detailedReportBodyOld.vue";
import dateformat from "dateformat";
import { mapGetters, mapActions } from "vuex";
import { dinrforms } from "../../districtmanager/api/forms/dinrforms.js";
export default {
  props: ["dinrs", "dras", "flatData"],
  name: "ManagerDetailed",
  components: {
    downloadexcel,
    DetailedHeader,
    ReviewBody
  },

  data() {
    return {
      id: "",
      signatureText: "",
      signature: {},
      dcSignature: {},
      officerSignature: {},
      officerPath: "",
      dcPath: "",
      numberOfTAs: "",
      dinrFormsData: {},
      villagesArray: [],
      campsArray: [],
      bufferDraFormsData: [],
      TAarray: [],
      draFormsData: [],
      download: [],
      downloadData: [],
      otherData: [],
      vhhousesvalue: "",
      filters: {
        Disaster: "all.dinrform.disaster",
        Country: "all.dinrform.district.admin0_name_en",
        "Country PCODE": "all.dinrform.district.admin0_pcode",
        District: "all.dinrform.district.admin2_name_en",
        Region: "all.dinrform.district.admin1_name_en",
        "TA PCODE": "all.admin3.admin3Pcode",
        TA: "all.admin3.admin3Name_en",
        "GVHS affected": "all.gvhsAffected",

        // "GVH affected": "gvhs.name",

        "Date of assessment ADRMC": "all.dinrform.doaAcpc",
        "Date of assessment DDRMC": "all.dinrform.doaDcpc",
        "Date of Disaster from": "all.dinrform.dodFrom",
        "Date of Disaster to": "all.dinrform.dodTo",
        "Date of submission": "all.dinrform.submited",

        //shelter

        "Houses partly damaged (shelter)": "all.sectors.shelter.partly_damaged",
        "Houses underwater (shelter)": "all.sectors.shelter.under_water",
        "Houses completely (shelter)": "all.sectors.shelter.completely_damaged",

        "number of males without shelter(shelter)":
          "all.shelter_without_shelter_male",
        "number of females without shelter (shelter)":
          "all.shelter_without_shelter_female",

        "number of female HH affected (shelter)": "all.shelter_fhh_affected",
        "number of male HH affected(shelter)": "all.shelter_mhh_affected",

        "Total Households affected (shelter)": "all.shelter_affected_hh",

        "number of injured females(shelter)":
          "all.shelter_people_injured_female",
        "number of injured males in category (shelter)":
          "all.shelter_people_injured_female",

        "Total people injured (shelter)": "all.shelter_injured",

        "number of dead females (shelter)": "all.shelter_people_dead_female",
        "number of dead males (shelter)": "all.shelter_people_dead_male",

        "Total people dead (shelter)": "all.shelter_dead",

        "Urgent needed (shelter)": "all.sectors.shelter.urgent_response_needed",
        "General response needed (shelter)":
          "all.sectors.shelter.response_needed",

        //displaced

        "number of displaced male Households (displaced)":
          "all.PeopleAffectedrows_male",
        "number of displaced females Households (displaced)":
          "all.PeopleAffectedrows_female",

        "Total displaced Households (shelter)": "all.displaced_hh",

        "number of male HH accomodated (displaced)":
          "all.displaced_households_accommodated_male",
        "number of female HH accomodated (displaced)":
          "all.displaced_households_accommodated_female",

        "number of males disaggregated (displaced)":
          "all.displaced_disagregated_male",
        "number of females disaggregated (displaced)":
          "all.displaced_disagregated_female",

        "number of males accomodated (displaced)":
          "all.displaced_individuals_accommodated_male",
        "number of females accomodated (displaced)":
          "all.displaced_individuals_accommodated_female",

        "Urgent response needed (displaced)":
          "all.sectors.displaced.urgent_response_needed",
        "general response needed (displaced)":
          "all.sectors.displaced.response_needed",

        //wash

        "FHH with safe water (wash)": "all.sectors.wash.with_safe_water_fhh",
        "MHH with safe water (wash)": "all.sectors.wash.with_safe_water_mhh",
        "FHH with toilet access (wash)":
          "all.sectors.wash.access_to_toilets_fhh",
        "MHH with toilet access (wash)":
          "all.sectors.wash.access_to_toilets_mhh",
        "FHH risking contamination (wash)":
          "all.sectors.wash.risk_contamination_fhh",
        "MHH risking contamination  (wash)":
          "all.sectors.wash.risk_contamination_mhh",

        "Urgent response needed (wash)":
          "all.sectors.wash.urgent_response_needed",

        "general response needed (wash)": "all.sectors.wash.response_needed",

        //health

        "number of facilities partially functioning (health)":
          "all.health_partially_functioning",
        "number of  facilities on verge of closing (health)":
          "all.health_verge_of_closing",
        "number  facilities closed (health)": "all.health_closed",

        "state of medical supply availability (health)":
          "all.medical_supply_availability",

        "state of health personnel availability (health)":
          "all.health_personel_availability",
        "Urgent response needed (health)":
          "all.sectors.health.urgent_response_needed",

        "general response needed (health)":
          "all.sectors.health.response_needed",

        //food

        "is food available? (food)": "all.is_food_available_food",

        "No. of FHH with 1-2 month Food Availability (food)":
          "all.food_1_2_months",
        "No. of FHH with less than 1 month Food Availability (food)":
          "all.food_less_1_month",

        "No. of FHH with more than 2 months Food Availability (food)":
          "all.food_2_months",

        "No. of FHH who lost Food Stock (food)": "all.food_stock_lost",

        "No. of MHH with 1-2 month Food Availability (food)":
          "all.food_1_2_months_male",
        "No. of MHH with less than 1 month Food Availability (food)":
          "all.food_less_1_month_male",

        "No. of MHH with more than 2 months Food Availability (food)":
          "all.food_2_months_male",

        "No. of MHH who lost Food Stock (food)": "all.food_stock_lost_male",

        "Urgent response needed (food)":
          "all.sectors.food.urgent_response_needed",
        "general response needed (food)": "all.sectors.food.response_needed",

        //logistics

        "state of access to main roads (logistics)": "all.road_access",

        "Urgent response needed (logistics)":
          "all.sectors.logistics.urgent_response_needed",

        "general response needed (logistics)":
          "all.sectors.logistics.response_needed",

        //agriculture
        "food items damaged (KGs) (agriculture)": "all.food_item_damage",
        "number of crop hectares submerged  (agriculture)":
          "all.hectares_submerged",
        "number crop hectares washed off  (agriculture)":
          "all.hectares_washed_away",
        "number of households whose crops are impacted (agriculture)":
          "all.impact_on_crops_hh_affected",
        "number of crop hectares damaged in affected households  (agriculture)":
          "all.impact_on_crops_hectares_damaged",

        "hh affected per impacted livestock  (agriculture)":
          "all.impact_on_livestock_hh",
        "number of impacted livestock  (agriculture)":
          "all.impact_on_livestock_la",

        "Urgent response needed (agriculture)":
          "all.sectors.agriculture.response_needed",

        "general response needed (agriculture)":
          "all.sectors.agriculture.response_needed",

        //protection

        "impacted females (protection)":
          "all.impact_on_vulnerable_persons_females",

        "impacted males (protection)": "all.impact_on_vulnerable_persons_males",

        "Urgent response needed (protection)":
          "all.sectors.protection.urgent_response_needed",

        "general response needed (protection)":
          "all.sectors.protection.response_needed",

        //nutrition

        "number of affected males (nutrition)":
          "all.nutrition_affected_pop_male",
        "number of affected females (nutrition)":
          "all.nutrition_affected_pop_female",

        "general response needed (nutrition)":
          "all.sectors.nutrition.response_needed",

        //education

        "number of school buildings functioning (education)":
          "all.education_building_functioning",
        "number of school buildings underwater (education)":
          "all.education_underwater",
        "number of school buildings completely damaged (education)":
          "all.education_completely_damaged",

        "number of school buildings partially functioning (education)":
          "all.education_building_partly_functioning",

        "number of school buildings closed  (education)":
          "all.education_closed_buildings",

        "males of out school (education)": "all.education_males_out_of_school",
        "females of out school (education)":
          "all.education_females_out_of_school",

        //livelihoods

        "number severely affected (livelihoods)":
          "all.livelihoods_severely_affected",

        "number slightly affected (livelihoods)":
          "all.livelihoods_slightly_affected",

        "Urgent response needed (livelihoods)":
          "all.sectors.livelihoods.response_needed",

        "Urgent response needed (environment)":
          "all.sectors.environment.urgent_response_needed",

        "general response needed (livelihoods)":
          "all.sectors.livelihoods.response_needed",

        "general response needed (environment)":
          "all.sectors.environment.response_needed"
      }
    };
  },

  computeLogo() {
    return "../../../../static/logo.png";
  },


  computed: {
    ...mapGetters({
      getDinrById: "dinrs/getById"
    }),
    ...mapGetters({
      getDraById: "dras/getById"
    }),

    hasPictures: function() {
      if ("disasterImages" in this.dinrFormsData) {
        return this.dinrFormsData.disasterImages.length > 0;
      }
      return false;
    }
  },
  beforeDestroy() {},
  async mounted() {
    await this.getDinrsAction();
    await this.getDrasAction();

    //Downloading PDF
    EventBus.$on("printPDF", async (self) => {
      var element = document.getElementById('section-to-print');
      var disasterdistrict = document.getElementById('district').innerHTML;
      var disastertype = document.getElementById('disastertype').innerHTML;
      var disasterdate = document.getElementById('disasterstart').innerHTML;

      var opt = {
        margin: 0,
        filename: disasterdate + "_" + disasterdistrict + "_" + disastertype,
        pagebreak: { mode: ['avoid-all', 'css', 'img'] },
        image: { type: 'jpeg', quality: 1 },
        html2canvas: { scale: 2, useCORS: true, allowTaint: true },
        jsPDF: { unit: 'in', format: 'a4', orientation: 'p' }
      };

      html2pdf().set(opt).from(element).save();
      self.modalShow = false;
    });
    //Get DINR Form

    let response = await this.getDinrById(
      this.$route.params.uuid /* , this.$session.get("jwt") */
    );
    this.dinrFormsData = {};
    this.dinrFormsData = response;


    //console.log(this.$route);

    //initialise number TAs in DNIR
    this.numberOfTAs = 0;

    let count = 0;
    //Get DRA Form

    response = this.getDraById(
      this.$route.params.uuid /* , this.$session.get("jwt") */
    );
    this.bufferDraFormsData = response;
    this.draFormsData = [];
    //console.log(bufferDraFormsData);
    this.downloadData.dinrform = {};

    this.bufferDraFormsData.forEach(item => {
      this.processExcel(item);

      this.TAarray.push(item.admin3.admin3Name_en.trim());
      for (let i in item.villages) {
        this.villagesArray.push(item.villages[i].name);
      }
      for (let i in item.camps) {
        this.campsArray.push(item.camps[i].name);
      }

      this.TAarray = this.TAarray.sort();

      this.villagesArray = this.villagesArray
        .join()
        .replace(/ /g, "")
        .split(",")
        .sort()
        .filter(function(item, pos, self) {
          return self.indexOf(item) == pos;
        });
      this.campsArray = this.campsArray
        .join()
        .replace(/ /g, "")
        .split(",")
        .sort()
        .filter(function(item, pos, self) {
          return self.indexOf(item) == pos;
        });
    });
  },

  methods: {
    disasterImage(disasterId, filename) {
      const resource = process.env.VUE_APP_ENGINE_URL + "/forms/dinr";

      return `${resource}/${disasterId}/images/${filename}`;
    },

    ...mapActions("dinrs", {
      getDinrsAction: "get"
    }),
    ...mapActions("dras", {
      getDrasAction: "get"
    }),
    formatedDatePlusOne(data) {
      const cur_date = this.addDays(data, 1);
      const finalDate = dateformat(cur_date, "dd-mm-yyyy");
      return finalDate;
    },

    addDays(date, days) {
      var result = new Date(date);
      result.setDate(result.getDate() + days);
      return result;
    },
    numberWithCommas(number) {
      try {
        var parts = number.toString().split(".");
        parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        return parts.join(".");
      } catch (e) {}
    },
    comparator(key, order = "asc") {
      return function innerSort(a, b) {
        if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
          return 0;
        }

        const varA = typeof a[key] === "string" ? a[key].toUpperCase() : a[key];
        const varB = typeof b[key] === "string" ? b[key].toUpperCase() : b[key];

        let comparison = 0;
        if (varA > varB) {
          comparison = 1;
        } else if (varA < varB) {
          comparison = -1;
        }
        return order === "desc" ? comparison * -1 : comparison;
      };
    },

    sortArrayByKey(arrayName) {
      return arrayName.slice().sort(this.comparator("name", "asc"));
    },
    downloadPDF() {
    var element = document.getElementById('section-to-print');
    var disasterdistrict = document.getElementById('district').innerHTML;
    var disastertype = document.getElementById('disastertype').innerHTML;
    var disasterdate = document.getElementById('disasterstart').innerHTML;

    var opt = {
      margin: 0,
      filename: disasterdate + "_" + disasterdistrict + "_" + disastertype,
      pagebreak: { mode: ['avoid-all', 'css', 'img'] },
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 2, useCORS: true, allowTaint: true },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'p' }
    };

    html2pdf().set(opt).from(element).save();
  },
    printdiv(printpage) {
      var headstr = "<html><head><title></title></head><body>";
      var footstr = "</body>";
      var newstr = document.all.item(printpage).innerHTML;
      var oldstr = document.body.innerHTML;
      var disasterdistrict = document.getElementById("district").innerHTML;
      var disastertype = document.getElementById("disastertype").innerHTML;
      var disasterdate = document.getElementById("disasterstart").innerHTML;

      document.body.innerHTML = headstr + newstr + footstr;
      document.title =
        disasterdate + "_" + disasterdistrict + "_" + disastertype;
      window.print();
      document.body.innerHTML = oldstr;
      location.reload();
      return false;
    },
    dateFormate(dateData) {
      const cur_date = dateData;
      const formattedDate = moment(cur_date).format("DD/MM/YYYY");

      return formattedDate;
    },
    formatdate(data) {
      const cur_date = data;
      const formattedDate = moment(cur_date).format("DD/MM/YYYY");
      return formattedDate;
    },

    formatedDate(data) {
      const cur_date = data;
      const formDate = moment(cur_date).format("YYYY/MM/DD");

      return formDate;
    },

    sumArrayValues(item, sector, array, key) {
      if (typeof item["sectors"][sector][array] !== "undefined") {
        return item["sectors"][sector][array]
          .map(function(item) {
            return parseInt(item[key]) ? parseInt(item[key]) : 0;
          })
          .reduce((sum, value) => sum + value, 0);
      } else if (typeof item[sector][array] === "undefined") {
        return 0;
      }
    },

    returnFieldvalue(item, sector, array, key) {
      if (typeof item["sectors"][sector][array] !== "undefined") {
        return item["sectors"][sector][array][0][key];
      } else if (typeof item["sectors"][sector][array] === "undefined") {
        return "NULL";
      }
    },

    returnFieldItemvalue(item, sector, array, key) {
      if (typeof item["sectors"][sector][array] !== "undefined") {
        for (let i in item["sectors"][sector][array]) {
          if (item["sectors"][sector][array][i].name === key) {
            return item["sectors"][sector][array][i].status;
          } else if (
            typeof item["sectors"][sector][array][i].key === "undefined"
          ) {
            return "NULL";
          }
        }
      }
    },

    sumArrayValuesNoAggregate(item, sector, array, key, filterBy, filterValue) {
      if (typeof item["sectors"][sector][array] !== "undefined") {
        return item["sectors"][sector][array]
          .filter(item => item[filterBy] === filterValue)
          .map(function(item) {
            return parseInt(item[key]) ? parseInt(item[key]) : 0;
          })
          .reduce((sum, value) => sum + value, 0);
      } else if (typeof item[sector][array] === "undefined") {
        return 0;
      }
    },

    processExcel(item) {
      this.downloadData.all = item;

      this.draFormsData.push(item);

      for (let i = 0; i < this.draFormsData.length; i++) {
        for (let a = 0; a < this.draFormsData[i].villages.length; a++) {
          this.villagesArray.push(this.draFormsData[i].villages[a].name);
        }

        for (let a = 0; a < this.draFormsData[i].camps.length; a++) {
          this.campsArray.push(this.draFormsData[i].camps[a].name);
        }
      }

      this.numberOfTAs++;

      let Gvharray = [];

      this.downloadData.dinrform = this.dinrFormsData;

      for (let i = 0; i < item.gvhs.length; i++) {
        let GVHname = item.gvhs[i].name;

        Gvharray.push(GVHname);
      }

      this.downloadData.all.dinrform = this.downloadData.dinrform;

      try {
        this.downloadData.all.dinrform.doaAcpc = this.formatedDate(
          this.downloadData.dinrform.doaAcpc
        );
      } catch (error) {
        this.downloadData.all.dinrform.doaAcpc = "NULL";
      }

      try {
        this.downloadData.all.dinrform.submited = this.formatedDatePlusOne(
          this.downloadData.all.dinrform.submitted_at
        );
      } catch (error) {
        this.downloadData.all.dinrform.submited = "";
      }

      try {
        this.downloadData.all.dinrform.doaDcpc = this.formatedDate(
          this.downloadData.dinrform.doaDcpc
        );
      } catch (error) {
        this.downloadData.all.dinrform.doaDcpc = "NULL";
      }

      try {
        this.downloadData.all.dinrform.dodFrom = this.formatedDate(
          this.downloadData.dinrform.dodFrom
        );
      } catch (error) {
        this.downloadData.all.dinrform.dodFrom = "NULL";
      }

      try {
        this.downloadData.all.dinrform.dodTo = this.formatedDate(
          this.downloadData.dinrform.dodTo
        );
      } catch (error) {
        this.downloadData.all.dinrform.dodTo = "NULL";
      }

      try {
        this.downloadData.all.gvhsAffected = Gvharray.join();
      } catch (error) {
        this.downloadData.all.gvhsAffected = "NULL";
      }

      try {
        this.downloadData.all.is_food_available_food = this.returnFieldvalue(
          item,
          "food",
          "food_availability",
          "foodavailable"
        );
      } catch (error) {
        this.downloadData.all.is_food_available_food = "NULL";
      }

      try {
        this.downloadData.all.medical_supply_availability = this.returnFieldItemvalue(
          item,
          "health",
          "available_health_medical",
          "Medical supply"
        );
      } catch (error) {
        this.downloadData.all.medical_supply_availability = "NULL";
      }

      try {
        this.downloadData.all.health_personel_availability = this.returnFieldItemvalue(
          item,
          "health",
          "available_health_medical",
          "Health personel"
        );
      } catch (error) {
        this.downloadData.all.health_personel_availability = "NULL";
      }

      try {
        this.downloadData.all.road_access =
          item.sectors.logistics.access_of_structures[0].accessibility;
      } catch (error) {
        this.downloadData.all.road_access = "NULL";
      }

      try {
        this.downloadData.all.food_1_2_months = this.sumArrayValuesNoAggregate(
          item,
          "food",
          "food_stocks_avaliability",
          "female_HH",
          "category",
          "No. of HH with 1-2 month Food Availability"
        );
      } catch (error) {
        this.downloadData.all.food_1_2_months = 0;
      }

      try {
        this.downloadData.all.food_2_months = this.sumArrayValuesNoAggregate(
          item,
          "food",
          "food_stocks_avaliability",
          "female_HH",
          "category",
          "No. of HH with more than 2 months Food Availability"
        );
      } catch (error) {
        this.downloadData.all.food_2_months = 0;
      }

      try {
        this.downloadData.all.food_stock_lost = this.sumArrayValuesNoAggregate(
          item,
          "food",
          "food_stocks_avaliability",
          "female_HH",
          "category",
          "No. of HH who lost Food Stock"
        );
      } catch (error) {
        this.downloadData.all.food_stock_lost = 0;
      }

      try {
        this.downloadData.all.food_less_1_month = this.sumArrayValuesNoAggregate(
          item,
          "food",
          "food_stocks_avaliability",
          "female_HH",
          "category",
          "No. of HH with less than 1 month Food Availability"
        );
      } catch (error) {
        this.downloadData.all.food_less_1_month = 0;
      }

      try {
        this.downloadData.all.food_less_1_month_male = this.sumArrayValuesNoAggregate(
          item,
          "food",
          "food_stocks_avaliability",
          "male_HH",
          "category",
          "No. of HH with less than 1 month Food Availability"
        );
      } catch (error) {
        this.downloadData.all.food_less_1_month_male = 0;
      }

      try {
        this.downloadData.all.food_1_2_months_male = this.sumArrayValuesNoAggregate(
          item,
          "food",
          "food_stocks_avaliability",
          "male_HH",
          "category",
          "No. of HH with 1-2 month Food Availability"
        );
      } catch (error) {
        this.downloadData.all.food_1_2_months_male = 0;
      }

      try {
        this.downloadData.all.food_2_months_male = this.sumArrayValuesNoAggregate(
          item,
          "food",
          "food_stocks_avaliability",
          "male_HH",
          "category",
          "No. of HH with more than 2 months Food Availability"
        );
      } catch (error) {
        this.downloadData.all.food_2_months_male = 0;
      }

      try {
        this.downloadData.all.food_stock_lost_male = this.sumArrayValuesNoAggregate(
          item,
          "food",
          "food_stocks_avaliability",
          "male_HH",
          "category",
          "No. of HH who lost Food Stock"
        );
      } catch (error) {
        this.downloadData.all.food_stock_lost_male = 0;
      }

      try {
        this.downloadData.all.food_item_damage = this.sumArrayValues(
          item,
          "agriculture",
          "food_item_damage",
          "number_of_kilos"
        );
      } catch (error) {
        this.downloadData.all.food_item_damage = 0;
      }
      try {
        this.downloadData.all.PeopleAffectedrows_female = this.sumArrayValues(
          item,
          "displaced",
          "PeopleAffectedrows",
          "number_displaced_by_gender_fhh"
        );
      } catch (error) {
        this.downloadData.all.PeopleAffectedrows_female = 0;
      }

      try {
        this.downloadData.all.PeopleAffectedrows_male = this.sumArrayValues(
          item,
          "displaced",
          "PeopleAffectedrows",
          "number_displaced_by_gender_mhh"
        );
      } catch (error) {
        this.downloadData.all.PeopleAffectedrows_male = 0;
      }

      try {
        this.downloadData.all.hectares_submerged = this.sumArrayValues(
          item,
          "agriculture",
          "crops_damaged",
          "hectares_submerged"
        );
      } catch (error) {
        this.downloadData.all.hectares_submerged = 0;
      }

      try {
        this.downloadData.all.hectares_washed_away = this.sumArrayValues(
          item,
          "agriculture",
          "crops_damaged",
          "hectares_washed_away"
        );
      } catch (error) {
        this.downloadData.all.hectares_washed_away = 0;
      }

      try {
        this.downloadData.all.impact_on_crops_hh_affected = this.sumArrayValues(
          item,
          "agriculture",
          "impact_on_crops",
          "hh_affected"
        );
      } catch (error) {
        this.downloadData.all.impact_on_crops_hh_affected = 0;
      }

      try {
        this.downloadData.all.impact_on_crops_hectares_damaged = this.sumArrayValues(
          item,
          "agriculture",
          "impact_on_crops",
          "hectares_damaged"
        );
      } catch (error) {
        this.downloadData.all.impact_on_crops_hectares_damaged = 0;
      }

      try {
        this.downloadData.all.impact_on_livestock_hh = this.sumArrayValues(
          item,
          "agriculture",
          "impact_on_livestock",
          "hh_affected_l"
        );
      } catch (error) {
        this.downloadData.all.impact_on_livestock_hh = 0;
      }

      try {
        this.downloadData.all.impact_on_livestock_la = this.sumArrayValues(
          item,
          "agriculture",
          "impact_on_livestock",
          "livestock_affected"
        );
      } catch (error) {
        this.downloadData.all.impact_on_livestock_la = 0;
      }

      try {
        this.downloadData.all.displaced_households_accommodated_male = this.sumArrayValues(
          item,
          "displaced",
          "displaced_households_accommodated",
          "accomodated_males_hh"
        );
      } catch (error) {
        this.downloadData.all.displaced_households_accommodated_male = 0;
      }
      try {
        this.downloadData.all.displaced_households_accommodated_female = this.sumArrayValues(
          item,
          "displaced",
          "displaced_households_accommodated",
          "accomodated_females_hh"
        );
      } catch (error) {
        this.downloadData.all.displaced_households_accommodated_female = 0;
      }

      try {
        this.downloadData.all.displaced_disagregated_male = this.sumArrayValues(
          item,
          "displaced",
          "displaced_disaggregated",
          "displaced_males"
        );
      } catch (error) {
        this.downloadData.all.displaced_disagregated_male = 0;
      }

      try {
        this.downloadData.all.displaced_disagregated_female = this.sumArrayValues(
          item,
          "displaced",
          "displaced_disaggregated",
          "displaced_females"
        );
      } catch (error) {
        this.downloadData.all.displaced_disagregated_female = 0;
      }

      try {
        this.downloadData.all.displaced_individuals_accommodated_male = this.sumArrayValues(
          item,
          "displaced",
          "displaced_individuals_accommodated",
          "accomodated_males"
        );
      } catch (error) {
        this.downloadData.all.displaced_individuals_accommodated_male = 0;
      }

      try {
        this.downloadData.all.displaced_individuals_accommodated_female = this.sumArrayValues(
          item,
          "displaced",
          "displaced_individuals_accommodated",
          "accomodated_females"
        );
      } catch (error) {
        this.downloadData.all.displaced_individuals_accommodated_female = 0;
      }

      try {
        this.downloadData.all.education_building_functioning = this.sumArrayValues(
          item,
          "education",
          "impact_on_schools",
          "functioning_buildings"
        );
      } catch (error) {
        this.downloadData.all.education_building_functioning = 0;
      }

      try {
        this.downloadData.all.education_building_partly_functioning = this.sumArrayValues(
          item,
          "education",
          "impact_on_schools",
          "partially_functioning_buildings"
        );
      } catch (error) {
        this.downloadData.all.education_building_partly_functioning = 0;
      }

      try {
        this.downloadData.all.education_closed_buildings = this.sumArrayValues(
          item,
          "education",
          "impact_on_schools",
          "closed_buildings"
        );
      } catch (error) {
        this.downloadData.all.education_closed_buildings = 0;
      }

      try {
        this.downloadData.all.education_females_out_of_school = this.sumArrayValues(
          item,
          "education",
          "impact_on_schools",
          "females_out_of_school"
        );
      } catch (error) {
        this.downloadData.all.education_females_out_of_school = 0;
      }

      try {
        this.downloadData.all.education_males_out_of_school = this.sumArrayValues(
          item,
          "education",
          "impact_on_schools",
          "males_out_of_school"
        );
      } catch (error) {
        this.downloadData.all.education_males_out_of_school = 0;
      }

      try {
        this.downloadData.all.education_underwater = this.sumArrayValues(
          item,
          "education",
          "impact_on_schools",
          "underwater"
        );
      } catch (error) {
        this.downloadData.all.education_underwater = 0;
      }

      try {
        this.downloadData.all.education_completely_damaged = this.sumArrayValues(
          item,
          "education",
          "impact_on_schools",
          "completely_damaged"
        );
      } catch (error) {
        this.downloadData.all.education_completely_damaged = 0;
      }

      try {
        this.downloadData.all.health_partially_functioning =
          this.sumArrayValues(
            item,
            "health",
            "available_health_facilities",
            "partially_functioning"
          ) +
          this.sumArrayValues(
            item,
            "health",
            "other_health_facilities",
            "partialy_functioning"
          );
      } catch (error) {
        this.downloadData.all.health_partially_functioning = 0;
      }

      try {
        this.downloadData.all.health_verge_of_closing =
          this.sumArrayValues(
            item,
            "health",
            "available_health_facilities",
            "verge_of_closing"
          ) +
          this.sumArrayValues(
            item,
            "health",
            "other_health_facilities",
            "verge_of_closing"
          );
      } catch (error) {
        this.downloadData.all.health_verge_of_closing = 0;
      }

      try {
        this.downloadData.all.health_closed =
          this.sumArrayValues(
            item,
            "health",
            "available_health_facilities",
            "closed"
          ) +
          this.sumArrayValues(
            item,
            "health",
            "other_health_facilities",
            "closed"
          );
      } catch (error) {
        this.downloadData.all.health_closed = 0;
      }

      try {
        this.downloadData.all.livelihoods_slightly_affected = this.sumArrayValues(
          item,
          "livelihoods",
          "livelihoods_affected",
          "severely_affected"
        );
      } catch (error) {
        this.downloadData.all.livelihoods_slightly_affected = 0;
      }
      try {
        this.downloadData.all.livelihoods_severely_affected = this.sumArrayValues(
          item,
          "livelihoods",
          "livelihoods_affected",
          "slightly_affected"
        );
      } catch (error) {
        this.downloadData.all.livelihoods_severely_affected = 0;
      }

      try {
        this.downloadData.all.impact_on_vulnerable_persons_males = this.sumArrayValues(
          item,
          "protection",
          "impact_on_vulnerable_persons",
          "impacted_males"
        );
      } catch (error) {
        this.downloadData.all.impact_on_vulnerable_persons_males = 0;
      }

      try {
        this.downloadData.all.impact_on_vulnerable_persons_females = this.sumArrayValues(
          item,
          "protection",
          "impact_on_vulnerable_persons",
          "impacted_females"
        );
      } catch (error) {
        this.downloadData.all.impact_on_vulnerable_persons_females = 0;
      }

      try {
        this.downloadData.all.nutrition_affected_pop_male = this.sumArrayValues(
          item,
          "nutrition",
          "affected_population",
          "affected_males"
        );
      } catch (error) {
        this.downloadData.all.nutrition_affected_pop_male = 0;
      }

      try {
        this.downloadData.all.nutrition_affected_pop_female = this.sumArrayValues(
          item,
          "nutrition",
          "affected_population",
          "affected_females"
        );
      } catch (error) {
        this.downloadData.all.nutrition_affected_pop_female = 0;
      }

      try {
        this.downloadData.all.shelter_without_shelter_male = this.sumArrayValues(
          item,
          "shelter",
          "people_without_shelter",
          "males"
        );
      } catch (error) {
        this.downloadData.all.shelter_without_shelter_male = 0;
      }

      try {
        this.downloadData.all.shelter_without_shelter_female = this.sumArrayValues(
          item,
          "shelter",
          "people_without_shelter",
          "females"
        );
      } catch (error) {
        this.downloadData.all.shelter_without_shelter_female = 0;
      }

      try {
        this.downloadData.all.shelter_people_dead_female = this.sumArrayValues(
          item,
          "shelter",
          "PeopleDeadrows",
          "females_dead"
        );
      } catch (error) {
        this.downloadData.all.shelter_people_dead_female = 0;
      }

      try {
        this.downloadData.all.shelter_people_dead_male = this.sumArrayValues(
          item,
          "shelter",
          "PeopleDeadrows",
          "males_dead"
        );
      } catch (error) {
        this.downloadData.all.shelter_people_dead_male = 0;
      }

      try {
        this.downloadData.all.shelter_people_injured_female = this.sumArrayValues(
          item,
          "shelter",
          "PeopleInjuredrows",
          "people_injured_females"
        );
      } catch (error) {
        this.downloadData.all.shelter_people_injured_female = 0;
      }

      try {
        this.downloadData.all.shelter_people_injured_male = this.sumArrayValues(
          item,
          "shelter",
          "PeopleInjuredrows",
          "people_injured_males"
        );
      } catch (error) {
        this.downloadData.all.shelter_people_injured_male = 0;
      }

      try {
        this.downloadData.all.shelter_fhh_affected = this.sumArrayValues(
          item,
          "shelter",
          "PeopleAffectedrows",
          "damaged_fhh"
        );
      } catch (error) {
        this.downloadData.all.shelter_fhh_affected = 0;
      }

      try {
        this.downloadData.all.shelter_mhh_affected = this.sumArrayValues(
          item,
          "shelter",
          "PeopleAffectedrows",
          "damaged_mhh"
        );
      } catch (error) {
        this.downloadData.all.shelter_mhh_affected = 0;
      }

      this.download.push({
        all: this.downloadData.all
      });
    }
  }
};
</script>
  
<style scoped>
  .modal-body .tags-input__wrapper {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
  
  .el-tag.el-tag--primary {
    position: relative !important;
    display: inline;
  }
  
  .image-previewer, .row {
    display: flex;
    flex-wrap: wrap;
    padding: 10px;
    justify-items: baseline;
  }
  
  .image-previewer .img, .row .img {
    height: 300px;
    border-radius: 10px;
    cursor: pointer;
  }
  
  .image-previewer .image--wrapper {
    position: relative;
    margin: 10px;
  }
  
  .row .image--wrapper {
    position: relative;
    margin: 10px;
  }
  
  .image-previewer .row .image--wrapper {
    margin: 10px;
  }
  
  .image--wrapper .img--overlay {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 10;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 10px;
  }
  
  .image--wrapper .img--overlay .btn {
    background: rgb(238, 5, 5);
    width: 100%;
    position: absolute;
    bottom: 0;
  }
  
  .progress, .progress-bar {
    height: 30px;
    font-weight: bold;
  }
  
  .inner {
    overflow: hidden;
  }
  
  .inner img {
    transition: all 1.5s ease;
  }
  
  .inner:hover img {
    transform: scale(2);
    display: flex;
    flex-wrap: wrap;
  }
  
  table {
    border-collapse: collapse;
    width: 100%;
    margin: 0 auto;
  }
  
  table, th, td {
    border: 1px solid black;
    margin-top: 1%;
  }
  
  td {
    padding: 1%;
  }
  
  .rotated {
    writing-mode: tb-rl;
    transform: rotate(-180deg);
    color: teal;
    padding-left: 30px;
  }
  
  .noborder {
    border: none;
  }
  
  .vertical {
    writing-mode: vertical-rl;
  }
  
  .qcont:first-letter {
    text-transform: capitalize;
  }
  
  .right-align {
    text-align: right;
  }
  
  @media print {
    .section-not-to-print {
      visibility: hidden;
    }
  
    #section-to-print {
      visibility: visible;
    }
  }
  </style>
  